var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _g, _path219, _path220, _g2, _path221, _path222, _g3, _path223, _path224, _g4, _path225, _path226, _g5, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroAiLot3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 530,
    viewBox: "0 0 800 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M770 7H30C13.4315 7 0 20.4315 0 37V507C0 523.569 13.4315 537 30 537H770C786.569 537 800 523.569 800 507V37C800 20.4315 786.569 7 770 7Z",
    fill: "#F9FDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.93 611.28C462.409 674.447 659.112 580.157 722.279 400.678C785.446 221.199 691.157 24.4962 511.678 -38.6708C332.199 -101.838 135.496 -7.54829 72.3287 171.931C9.16168 351.409 103.451 548.113 282.93 611.28ZM262.376 669.681C474.109 744.2 706.162 632.965 780.68 421.232C855.199 209.499 743.965 -22.5534 532.232 -97.072C320.499 -171.591 88.4461 -60.3565 13.9274 151.376C-60.5913 363.109 50.6429 595.162 262.376 669.681Z",
    fill: "#EFFAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.061 543.543C137.061 543.543 128.882 510.919 108.494 500.85C88.1063 490.782 66.3462 504.565 71.8716 519.061C76.6362 531.559 96.2277 516.191 111.471 522.235C126.714 528.28 129.117 543.543 129.117 543.543H137.061Z",
    fill: "#40A87B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.368 530.029C128.99 522.802 123.477 513.951 114.992 507.926C106.264 501.728 96.1115 502.049 88.3775 503.778C84.4888 504.647 81.1355 505.887 78.7556 506.908C77.5636 507.419 76.6104 507.878 75.9501 508.212C75.6199 508.379 75.3626 508.515 75.1849 508.61C75.096 508.658 75.0271 508.696 74.9788 508.723C74.9547 508.736 74.9358 508.747 74.9221 508.755L74.9056 508.764L74.8985 508.768C74.8985 508.768 74.8971 508.769 75.8094 510.37C76.7216 511.97 76.7208 511.971 76.7208 511.971L76.7285 511.966L76.7664 511.945C76.802 511.926 76.8579 511.895 76.9333 511.854C77.0841 511.773 77.3127 511.652 77.6125 511.501C78.2123 511.197 79.0954 510.772 80.2085 510.295C82.4386 509.338 85.5704 508.181 89.1813 507.374C96.4467 505.75 105.352 505.6 112.859 510.93C120.608 516.434 125.781 524.641 129.03 531.589C130.647 535.048 131.769 538.156 132.486 540.396C132.844 541.515 133.1 542.414 133.266 543.029C133.348 543.337 133.408 543.573 133.447 543.729C133.466 543.808 133.481 543.866 133.489 543.904L133.499 543.944L133.501 543.953C133.501 543.953 133.501 543.952 135.297 543.544C137.094 543.135 137.094 543.134 137.094 543.134L137.092 543.127L137.088 543.111L137.075 543.053C137.064 543.005 137.047 542.935 137.024 542.845C136.98 542.665 136.914 542.405 136.824 542.072C136.645 541.407 136.373 540.452 135.996 539.273C135.242 536.917 134.065 533.658 132.368 530.029Z",
    fill: "#6ADB6A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1725 505.067L80.0816 502.848L78.6094 506.227L83.7003 508.445L85.1725 505.067Z",
    fill: "#6ADB6A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6187 502.875L87.4786 498.119L85.9141 501.456L96.0542 506.211L97.6187 502.875Z",
    fill: "#6ADB6A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.611 504.826L103.336 498.595L100.523 500.976L105.799 507.207L108.611 504.826Z",
    fill: "#6ADB6A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.004 508.999L113.632 503.26L110.227 504.667L112.598 510.406L116.004 508.999Z",
    fill: "#6ADB6A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1238 504.43L80.3086 517.359L83.4623 519.266L91.2775 506.336L88.1238 504.43Z",
    fill: "#6ADB6A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.301 503.979L94.1326 515.49L97.2607 517.438L104.429 505.927L101.301 503.979Z",
    fill: "#6ADB6A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.42 511.526L107.645 512.867L108.099 516.523L118.875 515.183L118.42 511.526Z",
    fill: "#6ADB6A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.166 521.503L120.99 519.474L119.84 522.976L126.017 525.004L127.166 521.503Z",
    fill: "#6ADB6A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.205 542.52C146.205 542.52 151.976 433.161 99.7426 447.254C47.5096 461.347 140.487 520.285 140.408 542.52H146.205Z",
    fill: "#6ADB6A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.255 542.578C142.255 542.578 142.255 542.578 144.097 542.519C145.938 542.46 145.938 542.458 145.938 542.458V542.455V542.445L145.936 542.409C145.935 542.379 145.933 542.334 145.931 542.277C145.926 542.161 145.919 541.993 145.907 541.773C145.884 541.334 145.845 540.693 145.783 539.869C145.658 538.223 145.438 535.848 145.057 532.913C144.295 527.046 142.888 518.927 140.302 509.912C135.141 491.922 125.224 470.135 106.153 455.664L103.926 458.6C122.088 472.38 131.699 493.286 136.759 510.928C139.283 519.727 140.659 527.658 141.403 533.387C141.774 536.25 141.988 538.56 142.108 540.148C142.168 540.942 142.205 541.555 142.227 541.967C142.238 542.173 142.245 542.329 142.249 542.432C142.251 542.483 142.253 542.521 142.254 542.545L142.255 542.572V542.578Z",
    fill: "#40A87B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.602 454.083L119.532 473.785L123.213 473.611L122.283 453.909L118.602 454.083Z",
    fill: "#40A87B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.565 466.99L92.398 463.711L91.9219 467.365L117.088 470.645L117.565 466.99Z",
    fill: "#40A87B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M128.77 483.621L102.161 480.522L101.734 484.182L128.343 487.281L128.77 483.621Z",
    fill: "#40A87B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M136.06 500.097L115.508 497.192L114.992 500.841L135.545 503.746L136.06 500.097Z",
    fill: "#40A87B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M134.767 495.594L139.478 484.148L136.07 482.746L131.359 494.191L134.767 495.594Z",
    fill: "#40A87B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M127.806 481.43L131.822 465.316L128.247 464.425L124.23 480.538L127.806 481.43Z",
    fill: "#40A87B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.3 517.349L126.573 512.707L125.465 516.222L140.192 520.863L141.3 517.349Z",
    fill: "#40A87B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M434.728 387.379C434.728 401.691 432.555 415.492 428.529 428.475C423.239 445.485 414.759 461.106 403.795 474.6C403.779 474.615 403.779 474.615 403.779 474.615C389.669 491.965 371.426 505.842 350.562 514.726C347.169 516.176 343.715 517.485 340.183 518.658C326.412 523.268 311.67 525.75 296.357 525.75C238.621 525.75 189.135 490.376 168.409 440.134C161.701 423.866 158 406.054 158 387.379C158 377.51 159.033 367.887 160.991 358.59C161.161 357.769 161.346 356.955 161.531 356.137C164.908 341.516 170.599 327.791 178.201 315.349C191.294 293.897 210.061 276.301 232.421 264.63C233.439 264.104 234.472 263.578 235.506 263.086C237.788 261.959 240.101 260.895 242.46 259.893C249.832 256.778 257.542 254.281 265.515 252.461C275.43 250.194 285.763 249.006 296.357 249.006C298.546 249.006 300.721 249.051 302.88 249.161C366.152 252.075 418.335 297.522 431.522 357.587C431.629 358.079 431.738 358.571 431.829 359.082C433.509 367.131 434.482 375.444 434.697 383.94C434.728 385.082 434.728 386.222 434.728 387.379Z",
    fill: "#BBDBF3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M434.731 387.375C434.731 401.687 432.558 415.488 428.532 428.471C423.242 445.481 414.762 461.102 403.798 474.596C403.782 474.611 403.782 474.611 403.782 474.611C401.592 475.69 399.372 476.708 397.12 477.665C393.728 479.114 390.273 480.424 386.727 481.596C372.955 486.209 358.213 488.691 342.9 488.691C313.754 488.691 286.721 479.67 264.423 464.295C260.444 461.548 256.635 458.604 252.98 455.459C244.298 448.042 236.557 439.559 229.941 430.215C223.989 421.811 218.946 412.71 214.968 403.072C213.95 400.605 213.009 398.107 212.13 395.579C210.465 390.766 209.062 385.847 207.92 380.837C205.715 371.013 204.559 360.804 204.559 350.318C204.559 340.449 205.592 330.826 207.55 321.528C207.72 320.71 207.905 319.893 208.074 319.076C211.467 304.457 217.157 290.733 224.745 278.287C225.315 277.363 225.901 276.436 226.487 275.513C226.487 275.494 226.487 275.494 226.487 275.494C229.263 271.177 232.286 267.044 235.509 263.082C237.791 261.955 240.104 260.891 242.463 259.889C249.834 256.774 257.545 254.277 265.517 252.456C275.433 250.19 285.765 249.002 296.36 249.002C298.549 249.002 300.724 249.047 302.883 249.157C366.155 252.071 418.338 297.518 431.525 357.583C431.631 358.075 431.741 358.567 431.832 359.078C433.512 367.127 434.485 375.44 434.7 383.936C434.731 385.078 434.731 386.218 434.731 387.375Z",
    fill: "#E5F0F8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M242.985 502.812C240.116 503.38 231.912 500.651 227.471 497.196C223.015 493.76 205.481 480.387 202.89 479.093C200.315 477.799 198.002 468.747 195.427 464.444C192.836 460.127 188.379 455.238 186.081 453.232C183.784 451.227 180.191 446.633 179.188 444.32C178.17 442.035 175.024 439 173.729 438.429C172.434 437.842 172.572 432.397 170.275 431.829C168.902 431.489 168.517 436.223 168.409 440.124C161.701 423.856 158 406.044 158 387.369C158 377.5 159.033 367.877 160.991 358.58C162.333 357.051 164.106 356.094 168.378 355.386C172.65 354.66 169.134 357.963 168.378 359.844C167.622 361.709 167.7 363.143 168.378 365.301C169.072 367.446 173.868 368.169 176.459 368.895C179.049 369.603 176.027 365.872 176.459 363.143C176.89 360.412 181.779 362.281 183.059 362.849C184.354 363.435 187.809 362.849 189.243 362.712C190.677 362.572 192.697 361.415 195.565 360.983C198.433 360.552 197.292 362.572 196.429 364.869C195.565 367.166 195.427 367.877 195.704 370.33C195.997 372.766 200.593 379.381 201.456 380.089C202.32 380.815 203.183 381.818 203.754 384.115C204.34 386.412 204.91 389.727 206.052 389.575C207.208 389.436 207.486 391.888 210.369 394.325C211.048 394.896 211.618 395.297 212.127 395.573C213.006 398.102 213.947 400.599 214.965 403.066C218.943 412.705 223.986 421.805 229.939 430.209C229.568 430.811 229.214 431.349 228.905 431.814C227.178 434.372 226.885 441.312 227.903 442.886C228.905 444.472 229.908 445.751 231.635 448.483C233.362 451.227 234.226 450.072 235.937 451.072C237.665 452.09 239.823 456.532 241.689 458.844C243.555 461.144 243.848 463.733 241.258 464.876C238.667 466.015 238.821 470.764 238.25 472.77C237.665 474.79 241.396 474.93 242.275 476.936C243.123 478.953 245.144 478.953 245.421 480.111C245.714 481.253 242.692 483.842 243.555 485.14C244.419 486.419 247.287 489.302 246.578 491.168C245.853 493.034 247.009 496.194 247.58 498.786C248.151 501.377 245.853 502.225 242.985 502.812Z",
    fill: "#93C3E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M226.488 275.512C225.902 276.436 225.316 277.363 224.746 278.286C217.158 290.732 211.468 304.457 208.075 319.075C207.906 319.893 207.721 320.71 207.551 321.527C205.593 330.825 204.56 340.448 204.56 350.317C204.56 360.803 205.716 371.012 207.921 380.836C207.304 380.095 206.688 379.341 206.055 378.524C203.758 375.5 200.596 372.061 199.409 368.901C198.237 365.722 199.733 364.288 200.149 360.852C200.565 357.397 199.733 356.965 199.455 355.963C199.162 354.96 201.259 347.142 200.889 346.911C199.162 345.878 196.032 348.698 193.441 350.101C190.866 351.505 188.059 350.749 187.195 349.023C186.347 347.312 188.815 346.124 189.894 342.238C190.974 338.367 188.275 339.771 186.995 339.862C185.699 339.971 184.728 341.265 182.677 343.426C180.626 345.583 183.001 349.238 182.029 351.505C181.058 353.772 180.194 350.211 179.007 348.05C177.819 345.908 179.115 345.693 179.547 342.128C179.979 338.567 179.223 336.206 177.604 332.861C176 329.516 174.92 339.214 172.329 339.862C169.739 340.509 169.415 343.642 167.904 346.23C166.408 348.807 166.732 351.074 166.084 353.231C165.498 355.145 163.786 356.47 161.535 356.133C164.912 341.512 170.602 327.787 178.205 315.344C182.446 314.849 184.219 311.995 185.376 311.92C186.517 311.844 187.596 311.704 190.542 310.762C193.487 309.838 191.328 309.051 191.683 308.109C192.053 307.186 195.353 306.815 196.864 306.244C198.376 305.675 197.435 304.378 197.79 301.649C198.16 298.921 199.085 300.492 200.889 299.492C202.678 298.489 203.11 297.702 202.755 297.192C202.401 296.7 200.241 298.055 199.733 297.408C199.224 296.76 200.519 294.248 199.671 294.679C198.808 295.111 197.867 296.839 197.867 298.489C197.867 300.139 196.294 300.923 194.999 303.375C193.703 305.812 193.117 305.165 191.267 305.536C189.401 305.891 188.815 305.241 187.735 305.165C186.671 305.089 188.753 302.868 190.542 300.707C192.331 298.55 193.348 296.7 195.507 295.035C197.651 293.385 197.435 292.227 199.378 290.516C201.321 288.787 203.896 286.414 207.351 284.685C210.805 282.975 211.668 285.117 211.668 285.117C211.668 285.117 213.241 286.275 216.834 282.248C220.428 278.226 218.562 280.523 221.862 278.949C224.807 277.545 225.131 276.931 226.488 275.512Z",
    fill: "#93C3E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M369.44 365.305C369.578 366.308 366.556 367.019 363.256 364.503C359.956 361.99 358.228 362.285 355.792 360.711C353.34 359.122 352.199 358.259 350.04 354.528C347.881 350.781 348.452 349.499 347.449 346.77C346.447 344.042 344.149 345.476 343.131 347.202C342.129 348.928 338.69 348.344 336.377 347.633C334.095 346.91 334.095 344.473 329.916 342.313C325.752 340.156 324.457 341.742 321.156 342.021C317.856 342.313 314.68 345.613 312.243 346.91C309.807 348.205 310.516 349.207 310.377 351.365C310.239 353.51 306.491 359.122 304.486 360.988C302.466 362.853 304.193 363.285 305.921 366.448C307.648 369.608 307.509 368.468 307.077 370.611C306.645 372.771 305.643 374.497 305.489 377.52C305.35 380.525 304.193 382.409 302.62 382.409C301.032 382.409 298.596 379.231 297.161 376.223C295.712 373.202 292.982 372.339 288.541 369.903C284.084 367.45 285.519 366.603 283.36 362.716C281.201 358.83 279.767 357.533 279.196 359.262C278.625 360.988 276.467 359.262 272.58 358.551C268.71 357.828 268.417 355.667 265.117 353.665C261.817 351.659 259.658 354.664 257.637 355.281C255.633 355.898 252.749 357.828 250.421 358.83C248.092 359.848 244.561 359.122 242.278 359.553C239.965 359.985 236.233 359.693 233.365 359.553C230.481 359.417 229.479 357.117 226.611 355.281C223.727 353.464 223.018 355.53 221.861 356.685C220.72 357.828 222.431 358.551 224.698 360.711C226.95 362.853 227.906 362.285 230.204 364.442C232.501 366.603 234.645 368.174 236.526 366.016C238.392 363.871 239.533 364.287 241.985 364.442C244.422 364.582 247.737 363.579 249.31 363.719C250.883 363.871 250.744 368.605 249.171 371.337C247.583 374.065 249.881 377.936 249.171 378.66C248.447 379.386 246.01 379.677 244.422 380.96C242.849 382.254 241.985 383.98 239.102 384.983C236.233 385.985 236.804 387.866 236.233 389.872C235.663 391.892 231.915 393.466 228.615 395.332C225.315 397.197 224.591 400.652 222.431 400.789C220.288 400.929 220.997 397.352 219.995 393.898C218.993 390.443 214.675 391.029 212.67 387.374C211.19 384.706 209.586 382.825 207.92 380.835C205.715 371.012 204.559 360.802 204.559 350.316C204.559 340.447 205.592 330.824 207.55 321.526C207.72 320.709 207.905 319.892 208.074 319.074C211.467 304.456 217.157 290.731 224.745 278.285C225.315 277.362 225.901 276.435 226.487 275.511C226.487 275.493 226.487 275.493 226.487 275.493C226.657 275.311 226.842 275.125 227.042 274.925C228.908 273.059 230.774 273.196 233.643 273.196C236.526 273.196 238.099 272.625 240.69 271.33C243.265 270.036 240.119 267.444 241.831 264.87C243.558 262.279 248.447 263.281 250.02 261.987C251.608 260.689 252.749 259.687 255.926 258.684C259.072 257.669 260.66 256.818 262.526 255.232C263.251 254.615 264.392 253.534 265.517 252.455C275.433 250.188 285.765 249 296.36 249C298.549 249 300.724 249.046 302.883 249.155C304.456 250.049 305.874 250.729 306.645 250.775C309.082 250.915 310.377 251.361 314.263 252.656C318.134 253.95 317.995 254.801 319.429 256.095C320.864 257.39 321.434 255.955 325.181 254.938C328.913 253.95 327.911 257.25 332.799 257.821C337.672 258.392 341.697 262.987 344.719 264.87C347.742 266.736 348.452 266.873 347.156 269.173C345.861 271.47 346.308 271.902 347.31 274.354C348.313 276.791 350.611 275.928 351.767 276.28C352.908 276.636 355.206 278.225 357.072 279.227C358.938 280.227 360.233 282.974 359.231 284.253C358.228 285.547 354.928 284.408 354.635 281.956C354.342 279.519 351.474 279.811 349.038 277.237C346.586 274.676 346.447 277.93 345.445 279.364C344.427 280.813 343.579 280.227 341.697 278.085C339.831 275.928 339.986 278.38 338.829 280.227C337.672 282.111 339.399 283.25 341.127 284.685C342.854 286.119 343.286 284.408 344.149 283.837C345.013 283.25 346.725 281.679 346.308 283.837C345.861 285.982 346.879 287.863 348.452 286.982C350.04 286.119 350.472 288.139 352.338 290.3C354.204 292.442 356.208 292.873 359.524 294.168C362.824 295.465 361.529 297.054 362.685 300.214C363.826 303.374 364.69 306.537 364.551 309.266C364.412 311.995 364.829 313.429 362.685 316.297C360.526 319.181 360.233 319.46 356.501 320.894C352.769 322.344 355.067 321.049 353.479 321.757C351.906 322.481 352.199 324.055 351.767 327.078C351.32 330.101 352.908 329.515 355.206 331.396C357.504 333.261 359.955 332.83 363.117 333.832C366.263 334.835 366.124 335.838 367.28 338.15C368.422 340.447 368.715 341.45 367.419 343.316C366.124 345.181 366.849 347.202 366.988 350.07C367.142 352.939 364.829 352.507 364.258 348.636C363.687 344.75 362.253 347.478 360.094 347.478C357.936 347.478 356.933 345.752 354.342 345.041C351.767 344.318 352.199 345.476 350.611 347.633C349.038 349.779 351.906 352.367 352.769 354.664C353.633 356.965 356.362 356.685 360.094 357.828C363.826 358.985 363.117 358.551 365.276 361.143C367.419 363.719 369.285 364.287 369.44 365.305Z",
    fill: "#BBDBF3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M264.819 477.015C263.169 477.522 259.931 475.796 257.201 474.362C254.472 472.928 256.415 472.281 256.276 469.258C256.137 466.234 254.472 466.098 252.899 464.663C251.31 463.229 250.231 461.579 249.229 460.066C248.381 458.787 250.154 457.152 252.976 455.457C256.63 458.602 260.439 461.546 264.418 464.293C264.603 464.879 264.742 465.496 264.819 466.173C265.112 468.75 266.901 470.847 267.271 473.499C267.626 476.152 266.469 476.52 264.819 477.015Z",
    fill: "#93C3E6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M379.571 360.591C378.769 362.709 380.433 364.362 381.439 365.368C382.445 366.374 383.45 367.811 383.953 368.744C384.456 369.68 385.247 370.254 386.54 369.248C387.833 368.242 387.833 367.094 390.204 367.237C392.575 367.379 393.868 369.753 394.658 367.31C395.449 364.867 395.076 364.578 395.119 362.639C395.161 360.698 396.67 358.185 395.88 356.891C395.089 355.596 393.424 355.168 395.119 353.873C396.814 352.579 395.305 352.147 394.083 351.862C392.862 351.573 391.21 351.357 391.066 349.562C390.922 347.766 391.497 346.833 392.072 345.681C392.647 344.533 393.437 342.88 390.922 343.527C388.408 344.174 386.324 344.174 386.612 346.329C386.899 348.486 386.683 349.85 385.031 351.072C383.379 352.293 384.816 355.192 383.953 356.581C383.091 357.969 380.074 359.267 379.571 360.591Z",
    fill: "#BBDBF3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M354.342 267.891C351.855 268.273 357.467 269.507 358.976 271.88C360.484 274.25 363.825 274.034 362.424 277.052C361.023 280.069 360.269 279.637 360.915 281.47C361.562 283.302 359.622 284.918 361.239 284.918C362.855 284.918 364.903 284.381 366.519 286.428C368.136 288.473 368.136 286.535 366.735 283.84C365.334 281.148 365.118 280.285 365.873 278.99C366.627 277.699 366.843 275.651 365.334 273.925C363.825 272.202 362.803 272.74 361.051 270.908C359.299 269.076 355.742 267.675 354.342 267.891Z",
    fill: "#BBDBF3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M398.458 354.024C398.722 357.175 400.182 357.257 399.679 359.414C399.176 361.568 399.086 363.148 400.029 363.148C400.972 363.148 401.403 357.761 402.337 359.7C403.271 361.641 404.277 362.647 404.493 361.495C404.708 360.347 401.691 358.071 402.84 356.588C403.99 355.102 406.432 351.295 403.559 353.164C400.685 355.03 399.607 357.403 399.176 355.318C398.745 353.234 398.17 352.301 400.613 351.581C403.056 350.864 405.139 351.007 405.427 349.354C405.714 347.704 405.929 344.325 403.702 346.698C401.475 349.068 401.331 348.709 399.535 349.931C397.739 351.149 396.015 351.222 396.733 352.228C397.452 353.234 398.337 352.584 398.458 354.024Z",
    fill: "#BBDBF3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M378.809 316.482C376.753 316.585 376.977 317.989 378.271 319.499C379.564 321.009 379.779 322.732 381.504 324.349C383.228 325.965 385.276 326.612 385.707 328.013C386.138 329.414 387.807 327.904 387.727 326.397C387.646 324.886 389.802 325.534 390.88 326.612C391.957 327.688 393.143 327.618 393.681 328.569C394.22 329.52 396.268 328.013 394.113 326.612C391.957 325.212 391.634 324.564 389.371 323.701C387.108 322.842 387.375 322.948 386.271 323.701C385.168 324.455 384.413 324.713 383.012 322.483C381.612 320.253 382.109 318.205 380.944 317.129C379.779 316.05 380.965 316.373 378.809 316.482Z",
    fill: "#BBDBF3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M611.547 227.031H633.322V62.7861H611.547V227.031ZM634.367 229.121H610.502C609.924 229.121 609.457 228.654 609.457 228.076V61.7442C609.457 61.1662 609.924 60.6957 610.502 60.6957H634.367C634.945 60.6957 635.412 61.1662 635.412 61.7442V228.076C635.412 228.654 634.945 229.121 634.367 229.121Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M610.74 77.3354H634.141L665.363 62.7899H579.518L610.74 77.3354ZM634.373 79.4258H610.508C610.354 79.4258 610.206 79.3922 610.068 79.3283L574.36 62.6925C573.913 62.4875 573.674 62.0002 573.778 61.5196C573.886 61.0423 574.309 60.6996 574.8 60.6996H670.081C670.572 60.6996 670.995 61.0423 671.1 61.5196C671.207 62.0002 670.965 62.4875 670.521 62.6925L634.813 79.3283C634.675 79.3922 634.524 79.4258 634.373 79.4258Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M566.81 93.9682H678.069L634.204 79.4261H610.675L566.81 93.9682ZM684.545 96.0586H560.334C559.82 96.0586 559.383 95.6856 559.302 95.1814C559.222 94.674 559.517 94.1833 560.005 94.022L610.178 77.3861C610.285 77.3525 610.393 77.3357 610.507 77.3357H634.372C634.483 77.3357 634.594 77.3525 634.701 77.3861L684.871 94.022C685.358 94.1833 685.657 94.674 685.577 95.1814C685.493 95.6856 685.056 96.0586 684.545 96.0586Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M561.379 99.6033V109.706L572.154 99.6033H561.379ZM560.334 113.164C560.193 113.164 560.052 113.134 559.921 113.077C559.538 112.912 559.289 112.532 559.289 112.116V98.5581C559.289 97.9801 559.756 97.5129 560.334 97.5129H574.799C575.229 97.5129 575.612 97.7751 575.77 98.175C575.928 98.5716 575.827 99.0253 575.515 99.321L561.05 112.878C560.852 113.067 560.596 113.164 560.334 113.164Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M560.334 137.168C559.756 137.168 559.289 136.701 559.289 136.123V112.12C559.289 111.545 559.756 111.075 560.334 111.075C560.912 111.075 561.379 111.545 561.379 112.12V136.123C561.379 136.701 560.912 137.168 560.334 137.168Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 136.797H558.707C558.428 136.797 558.199 136.568 558.199 136.286C558.199 136.007 558.428 135.779 558.707 135.779H561.96C562.242 135.779 562.471 136.007 562.471 136.286C562.471 136.568 562.242 136.797 561.96 136.797Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 133.988H558.707C558.428 133.988 558.199 133.76 558.199 133.481C558.199 133.202 558.428 132.973 558.707 132.973H561.96C562.242 132.973 562.471 133.202 562.471 133.481C562.471 133.76 562.242 133.988 561.96 133.988Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 131.176H558.707C558.428 131.176 558.199 130.947 558.199 130.665C558.199 130.386 558.428 130.157 558.707 130.157H561.96C562.242 130.157 562.471 130.386 562.471 130.665C562.471 130.947 562.242 131.176 561.96 131.176Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 128.379H558.707C558.428 128.379 558.199 128.15 558.199 127.871C558.199 127.592 558.428 127.364 558.707 127.364H561.96C562.242 127.364 562.471 127.592 562.471 127.871C562.471 128.15 562.242 128.379 561.96 128.379Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 125.566H558.707C558.428 125.566 558.199 125.338 558.199 125.059C558.199 124.777 558.428 124.548 558.707 124.548H561.96C562.242 124.548 562.471 124.777 562.471 125.059C562.471 125.338 562.242 125.566 561.96 125.566Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 122.758H558.707C558.428 122.758 558.199 122.529 558.199 122.25C558.199 121.971 558.428 121.743 558.707 121.743H561.96C562.242 121.743 562.471 121.971 562.471 122.25C562.471 122.529 562.242 122.758 561.96 122.758Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 119.953H558.707C558.428 119.953 558.199 119.725 558.199 119.446C558.199 119.163 558.428 118.935 558.707 118.935H561.96C562.242 118.935 562.471 119.163 562.471 119.446C562.471 119.725 562.242 119.953 561.96 119.953Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 117.141H558.707C558.428 117.141 558.199 116.912 558.199 116.633C558.199 116.354 558.428 116.126 558.707 116.126H561.96C562.242 116.126 562.471 116.354 562.471 116.633C562.471 116.912 562.242 117.141 561.96 117.141Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 114.332H558.707C558.428 114.332 558.199 114.104 558.199 113.825C558.199 113.542 558.428 113.314 558.707 113.314H561.96C562.242 113.314 562.471 113.542 562.471 113.825C562.471 114.104 562.242 114.332 561.96 114.332Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M672.718 99.6033L683.496 109.706V99.6033H672.718ZM684.541 113.164C684.279 113.164 684.023 113.067 683.825 112.878L669.36 99.321C669.048 99.0253 668.947 98.5716 669.105 98.175C669.26 97.7751 669.646 97.5129 670.076 97.5129H684.541C685.119 97.5129 685.586 97.9801 685.586 98.5581V112.116C685.586 112.532 685.338 112.912 684.954 113.077C684.82 113.134 684.682 113.164 684.541 113.164Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M684.541 137.168C683.963 137.168 683.496 136.701 683.496 136.123V112.12C683.496 111.545 683.963 111.075 684.541 111.075C685.119 111.075 685.587 111.545 685.587 112.12V136.123C685.587 136.701 685.119 137.168 684.541 137.168Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 136.797H686.178C686.457 136.797 686.686 136.568 686.686 136.286C686.686 136.007 686.457 135.779 686.178 135.779H682.922C682.643 135.779 682.414 136.007 682.414 136.286C682.414 136.568 682.643 136.797 682.922 136.797Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 133.988H686.178C686.457 133.988 686.686 133.76 686.686 133.481C686.686 133.202 686.457 132.973 686.178 132.973H682.922C682.643 132.973 682.414 133.202 682.414 133.481C682.414 133.76 682.643 133.988 682.922 133.988Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 131.176H686.178C686.457 131.176 686.686 130.947 686.686 130.665C686.686 130.386 686.457 130.157 686.178 130.157H682.922C682.643 130.157 682.414 130.386 682.414 130.665C682.414 130.947 682.643 131.176 682.922 131.176Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 128.379H686.178C686.457 128.379 686.686 128.15 686.686 127.871C686.686 127.592 686.457 127.364 686.178 127.364H682.922C682.643 127.364 682.414 127.592 682.414 127.871C682.414 128.15 682.643 128.379 682.922 128.379Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 125.566H686.178C686.457 125.566 686.686 125.338 686.686 125.059C686.686 124.777 686.457 124.548 686.178 124.548H682.922C682.643 124.548 682.414 124.777 682.414 125.059C682.414 125.338 682.643 125.566 682.922 125.566Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 122.758H686.178C686.457 122.758 686.686 122.529 686.686 122.25C686.686 121.971 686.457 121.743 686.178 121.743H682.922C682.643 121.743 682.414 121.971 682.414 122.25C682.414 122.529 682.643 122.758 682.922 122.758Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 119.953H686.178C686.457 119.953 686.686 119.725 686.686 119.446C686.686 119.163 686.457 118.935 686.178 118.935H682.922C682.643 118.935 682.414 119.163 682.414 119.446C682.414 119.725 682.643 119.953 682.922 119.953Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 117.141H686.178C686.457 117.141 686.686 116.912 686.686 116.633C686.686 116.354 686.457 116.126 686.178 116.126H682.922C682.643 116.126 682.414 116.354 682.414 116.633C682.414 116.912 682.643 117.141 682.922 117.141Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 114.332H686.178C686.457 114.332 686.686 114.104 686.686 113.825C686.686 113.542 686.457 113.314 686.178 113.314H682.922C682.643 113.314 682.414 113.542 682.414 113.825C682.414 114.104 682.643 114.332 682.922 114.332Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M566.807 227.038H678.069L634.204 212.493H610.675L566.807 227.038ZM684.545 229.129H560.334C559.82 229.129 559.383 228.756 559.302 228.248C559.222 227.744 559.517 227.254 560.005 227.092L610.178 210.456C610.285 210.419 610.393 210.403 610.507 210.403H634.372C634.483 210.403 634.594 210.419 634.701 210.456L684.871 227.092C685.358 227.254 685.657 227.744 685.577 228.248C685.493 228.756 685.056 229.129 684.545 229.129Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M561.379 232.224V242.327L572.154 232.224H561.379ZM560.334 245.785C560.193 245.785 560.052 245.758 559.921 245.698C559.538 245.533 559.289 245.157 559.289 244.74V231.179C559.289 230.601 559.756 230.134 560.334 230.134H574.799C575.229 230.134 575.612 230.396 575.77 230.796C575.928 231.193 575.827 231.65 575.515 231.942L561.05 245.503C560.852 245.688 560.596 245.785 560.334 245.785Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M560.334 269.785C559.756 269.785 559.289 269.318 559.289 268.74V244.741C559.289 244.163 559.756 243.695 560.334 243.695C560.912 243.695 561.379 244.163 561.379 244.741V268.74C561.379 269.318 560.912 269.785 560.334 269.785Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 266.609H558.707C558.428 266.609 558.199 266.381 558.199 266.099C558.199 265.82 558.428 265.591 558.707 265.591H561.96C562.242 265.591 562.471 265.82 562.471 266.099C562.471 266.381 562.242 266.609 561.96 266.609Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 263.793H558.707C558.428 263.793 558.199 263.564 558.199 263.286C558.199 263.007 558.428 262.778 558.707 262.778H561.96C562.242 262.778 562.471 263.007 562.471 263.286C562.471 263.564 562.242 263.793 561.96 263.793Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 260.992H558.707C558.428 260.992 558.199 260.764 558.199 260.481C558.199 260.202 558.428 259.974 558.707 259.974H561.96C562.242 259.974 562.471 260.202 562.471 260.481C562.471 260.764 562.242 260.992 561.96 260.992Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 258.184H558.707C558.428 258.184 558.199 257.955 558.199 257.676C558.199 257.397 558.428 257.169 558.707 257.169H561.96C562.242 257.169 562.471 257.397 562.471 257.676C562.471 257.955 562.242 258.184 561.96 258.184Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 255.375H558.707C558.428 255.375 558.199 255.146 558.199 254.868C558.199 254.585 558.428 254.357 558.707 254.357H561.96C562.242 254.357 562.471 254.585 562.471 254.868C562.471 255.146 562.242 255.375 561.96 255.375Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 252.566H558.707C558.428 252.566 558.199 252.338 558.199 252.059C558.199 251.78 558.428 251.551 558.707 251.551H561.96C562.242 251.551 562.471 251.78 562.471 252.059C562.471 252.338 562.242 252.566 561.96 252.566Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 249.762H558.707C558.428 249.762 558.199 249.533 558.199 249.254C558.199 248.972 558.428 248.743 558.707 248.743H561.96C562.242 248.743 562.471 248.972 562.471 249.254C562.471 249.533 562.242 249.762 561.96 249.762Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96 246.949H558.707C558.428 246.949 558.199 246.721 558.199 246.442C558.199 246.163 558.428 245.934 558.707 245.934H561.96C562.242 245.934 562.471 246.163 562.471 246.442C562.471 246.721 562.242 246.949 561.96 246.949Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M672.718 232.224L683.496 242.327V232.224H672.718ZM684.541 245.785C684.279 245.785 684.023 245.688 683.825 245.503L669.36 231.942C669.048 231.65 668.947 231.193 669.105 230.796C669.26 230.396 669.646 230.134 670.076 230.134H684.541C685.119 230.134 685.586 230.601 685.586 231.179V244.74C685.586 245.157 685.338 245.533 684.954 245.698C684.82 245.758 684.682 245.785 684.541 245.785Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M684.541 269.785C683.963 269.785 683.496 269.318 683.496 268.74V244.741C683.496 244.163 683.963 243.695 684.541 243.695C685.119 243.695 685.587 244.163 685.587 244.741V268.74C685.587 269.318 685.119 269.785 684.541 269.785Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 266.609H686.178C686.457 266.609 686.686 266.381 686.686 266.099C686.686 265.82 686.457 265.591 686.178 265.591H682.922C682.643 265.591 682.414 265.82 682.414 266.099C682.414 266.381 682.643 266.609 682.922 266.609Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 263.793H686.178C686.457 263.793 686.686 263.564 686.686 263.286C686.686 263.007 686.457 262.778 686.178 262.778H682.922C682.643 262.778 682.414 263.007 682.414 263.286C682.414 263.564 682.643 263.793 682.922 263.793Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 260.992H686.178C686.457 260.992 686.686 260.764 686.686 260.481C686.686 260.202 686.457 259.974 686.178 259.974H682.922C682.643 259.974 682.414 260.202 682.414 260.481C682.414 260.764 682.643 260.992 682.922 260.992Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 258.184H686.178C686.457 258.184 686.686 257.955 686.686 257.676C686.686 257.397 686.457 257.169 686.178 257.169H682.922C682.643 257.169 682.414 257.397 682.414 257.676C682.414 257.955 682.643 258.184 682.922 258.184Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 255.375H686.178C686.457 255.375 686.686 255.146 686.686 254.868C686.686 254.585 686.457 254.357 686.178 254.357H682.922C682.643 254.357 682.414 254.585 682.414 254.868C682.414 255.146 682.643 255.375 682.922 255.375Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 252.566H686.178C686.457 252.566 686.686 252.338 686.686 252.059C686.686 251.78 686.457 251.551 686.178 251.551H682.922C682.643 251.551 682.414 251.78 682.414 252.059C682.414 252.338 682.643 252.566 682.922 252.566Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 249.762H686.178C686.457 249.762 686.686 249.533 686.686 249.254C686.686 248.972 686.457 248.743 686.178 248.743H682.922C682.643 248.743 682.414 248.972 682.414 249.254C682.414 249.533 682.643 249.762 682.922 249.762Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M682.922 246.949H686.178C686.457 246.949 686.686 246.721 686.686 246.442C686.686 246.163 686.457 245.934 686.178 245.934H682.922C682.643 245.934 682.414 246.163 682.414 246.442C682.414 246.721 682.643 246.949 682.922 246.949Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M689.041 181.642L699.815 191.745V181.642H689.041ZM700.861 195.203C700.602 195.203 700.343 195.106 700.148 194.921L685.683 181.36C685.371 181.068 685.267 180.614 685.424 180.214C685.582 179.814 685.969 179.552 686.396 179.552H700.861C701.439 179.552 701.906 180.023 701.906 180.597V194.158C701.906 194.575 701.66 194.951 701.277 195.116C701.143 195.176 701.002 195.203 700.861 195.203Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M700.866 219.203C700.287 219.203 699.82 218.733 699.82 218.158V194.155C699.82 193.577 700.287 193.11 700.866 193.11C701.444 193.11 701.911 193.577 701.911 194.155V218.158C701.911 218.733 701.444 219.203 700.866 219.203Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M699.234 218.832H702.487C702.77 218.832 702.998 218.604 702.998 218.325C702.998 218.046 702.77 217.817 702.487 217.817H699.234C698.955 217.817 698.727 218.046 698.727 218.325C698.727 218.604 698.955 218.832 699.234 218.832Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M699.234 216.027H702.487C702.77 216.027 702.998 215.799 702.998 215.517C702.998 215.238 702.77 215.009 702.487 215.009H699.234C698.955 215.009 698.727 215.238 698.727 215.517C698.727 215.799 698.955 216.027 699.234 216.027Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M699.234 213.211H702.487C702.77 213.211 702.998 212.982 702.998 212.703C702.998 212.425 702.77 212.196 702.487 212.196H699.234C698.955 212.196 698.727 212.425 698.727 212.703C698.727 212.982 698.955 213.211 699.234 213.211Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M699.234 210.402H702.487C702.77 210.402 702.998 210.174 702.998 209.895C702.998 209.613 702.77 209.384 702.487 209.384H699.234C698.955 209.384 698.727 209.613 698.727 209.895C698.727 210.174 698.955 210.402 699.234 210.402Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M699.234 207.598H702.487C702.77 207.598 702.998 207.369 702.998 207.09C702.998 206.811 702.77 206.583 702.487 206.583H699.234C698.955 206.583 698.727 206.811 698.727 207.09C698.727 207.369 698.955 207.598 699.234 207.598Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M699.234 204.789H702.487C702.77 204.789 702.998 204.561 702.998 204.282C702.998 203.999 702.77 203.771 702.487 203.771H699.234C698.955 203.771 698.727 203.999 698.727 204.282C698.727 204.561 698.955 204.789 699.234 204.789Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M699.234 201.98H702.487C702.77 201.98 702.998 201.752 702.998 201.473C702.998 201.194 702.77 200.966 702.487 200.966H699.234C698.955 200.966 698.727 201.194 698.727 201.473C698.727 201.752 698.955 201.98 699.234 201.98Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M699.234 199.18H702.487C702.77 199.18 702.998 198.951 702.998 198.672C702.998 198.39 702.77 198.161 702.487 198.161H699.234C698.955 198.161 698.727 198.39 698.727 198.672C698.727 198.951 698.955 199.18 699.234 199.18Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M699.234 196.375H702.487C702.77 196.375 702.998 196.143 702.998 195.864C702.998 195.585 702.77 195.357 702.487 195.357H699.234C698.955 195.357 698.727 195.585 698.727 195.864C698.727 196.143 698.955 196.375 699.234 196.375Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M547.059 181.642V191.745L557.837 181.642H547.059ZM546.014 195.203C545.873 195.203 545.732 195.176 545.601 195.116C545.217 194.951 544.969 194.575 544.969 194.158V180.597C544.969 180.023 545.436 179.552 546.014 179.552H560.479C560.906 179.552 561.292 179.814 561.45 180.214C561.608 180.614 561.507 181.068 561.195 181.36L546.73 194.921C546.532 195.106 546.276 195.203 546.014 195.203Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M546.014 219.203C545.436 219.203 544.969 218.733 544.969 218.158V194.155C544.969 193.577 545.436 193.11 546.014 193.11C546.592 193.11 547.059 193.577 547.059 194.155V218.158C547.059 218.733 546.592 219.203 546.014 219.203Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M547.644 218.832H544.39C544.111 218.832 543.883 218.604 543.883 218.325C543.883 218.046 544.111 217.817 544.39 217.817H547.644C547.926 217.817 548.154 218.046 548.154 218.325C548.154 218.604 547.926 218.832 547.644 218.832Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M547.644 216.027H544.39C544.111 216.027 543.883 215.799 543.883 215.517C543.883 215.238 544.111 215.009 544.39 215.009H547.644C547.926 215.009 548.154 215.238 548.154 215.517C548.154 215.799 547.926 216.027 547.644 216.027Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M547.644 213.211H544.39C544.111 213.211 543.883 212.982 543.883 212.703C543.883 212.425 544.111 212.196 544.39 212.196H547.644C547.926 212.196 548.154 212.425 548.154 212.703C548.154 212.982 547.926 213.211 547.644 213.211Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M547.644 210.402H544.39C544.111 210.402 543.883 210.174 543.883 209.895C543.883 209.613 544.111 209.384 544.39 209.384H547.644C547.926 209.384 548.154 209.613 548.154 209.895C548.154 210.174 547.926 210.402 547.644 210.402Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M547.644 207.598H544.39C544.111 207.598 543.883 207.369 543.883 207.09C543.883 206.811 544.111 206.583 544.39 206.583H547.644C547.926 206.583 548.154 206.811 548.154 207.09C548.154 207.369 547.926 207.598 547.644 207.598Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M547.644 204.789H544.39C544.111 204.789 543.883 204.561 543.883 204.282C543.883 203.999 544.111 203.771 544.39 203.771H547.644C547.926 203.771 548.154 203.999 548.154 204.282C548.154 204.561 547.926 204.789 547.644 204.789Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M547.644 201.98H544.39C544.111 201.98 543.883 201.752 543.883 201.473C543.883 201.194 544.111 200.966 544.39 200.966H547.644C547.926 200.966 548.154 201.194 548.154 201.473C548.154 201.752 547.926 201.98 547.644 201.98Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M547.644 199.18H544.39C544.111 199.18 543.883 198.951 543.883 198.672C543.883 198.39 544.111 198.161 544.39 198.161H547.644C547.926 198.161 548.154 198.39 548.154 198.672C548.154 198.951 547.926 199.18 547.644 199.18Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M547.644 196.375H544.39C544.111 196.375 543.883 196.143 543.883 195.864C543.883 195.585 544.111 195.357 544.39 195.357H547.644C547.926 195.357 548.154 195.585 548.154 195.864C548.154 196.143 547.926 196.375 547.644 196.375Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M574.799 67.5392C574.221 67.5392 573.754 67.0686 573.754 66.4939V61.7485C573.754 61.1705 574.221 60.7 574.799 60.7C575.377 60.7 575.844 61.1705 575.844 61.7485V66.4939C575.844 67.0686 575.377 67.5392 574.799 67.5392Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M670.076 67.5392C669.498 67.5392 669.031 67.0686 669.031 66.4939V61.7485C669.031 61.1705 669.498 60.7 670.076 60.7C670.654 60.7 671.122 61.1705 671.122 61.7485V66.4939C671.122 67.0686 670.654 67.5392 670.076 67.5392Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M550.801 177.085H694.081L634.215 158.564H610.666L550.801 177.085ZM700.997 179.176H543.884C543.367 179.176 542.927 178.799 542.853 178.285C542.772 177.774 543.081 177.284 543.575 177.132L610.199 156.521C610.297 156.491 610.401 156.474 610.508 156.474H634.373C634.477 156.474 634.582 156.491 634.682 156.521L701.307 177.132C701.801 177.284 702.106 177.774 702.029 178.285C701.955 178.799 701.515 179.176 700.997 179.176Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M675.03 524.988H686.759L633.497 229.125H611.376L558.115 524.988H569.844L621.519 430.795C621.889 430.126 622.988 430.126 623.354 430.795L675.03 524.988ZM688.009 527.078H674.411C674.031 527.078 673.679 526.87 673.494 526.537L622.437 433.47L571.38 526.537C571.195 526.87 570.845 527.078 570.462 527.078H556.865C556.555 527.078 556.263 526.94 556.065 526.705C555.867 526.466 555.782 526.151 555.836 525.848L609.474 227.895C609.565 227.398 609.998 227.035 610.503 227.035H634.371C634.878 227.035 635.312 227.398 635.399 227.895L689.037 525.848C689.091 526.151 689.007 526.466 688.812 526.705C688.61 526.94 688.318 527.078 688.009 527.078Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M610.502 79.4258C610.173 79.4258 609.847 79.2678 609.645 78.9788C609.316 78.5049 609.43 77.853 609.904 77.5236L633.769 60.8877C634.242 60.5584 634.894 60.676 635.224 61.1499C635.553 61.6238 635.439 62.2724 634.965 62.6051L611.097 79.2376C610.915 79.3653 610.707 79.4258 610.502 79.4258Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M634.367 79.4258C634.158 79.4258 633.95 79.3653 633.769 79.2376L609.904 62.6051C609.43 62.2724 609.316 61.6238 609.645 61.1499C609.971 60.676 610.623 60.555 611.097 60.8877L634.965 77.5236C635.439 77.853 635.553 78.5049 635.224 78.9788C635.022 79.2678 634.696 79.4258 634.367 79.4258Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M610.502 96.0586C610.173 96.0586 609.847 95.904 609.645 95.6116C609.316 95.1377 609.43 94.4858 609.904 94.1564L633.769 77.5239C634.246 77.1912 634.894 77.3088 635.224 77.7827C635.553 78.2566 635.439 78.9085 634.965 79.2379L611.1 95.8704C610.915 95.9981 610.707 96.0586 610.502 96.0586Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M634.367 96.0586C634.158 96.0586 633.95 95.9981 633.769 95.8704L609.904 79.2379C609.43 78.9085 609.316 78.2566 609.645 77.7827C609.971 77.3088 610.623 77.1912 611.1 77.5239L634.965 94.1564C635.439 94.4858 635.553 95.1377 635.224 95.6116C635.022 95.904 634.696 96.0586 634.367 96.0586Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M610.502 112.691C610.173 112.691 609.847 112.537 609.645 112.244C609.316 111.771 609.43 111.119 609.904 110.789L633.769 94.1567C634.242 93.824 634.894 93.9416 635.224 94.4155C635.553 94.8893 635.439 95.5414 634.965 95.8707L611.097 112.503C610.915 112.631 610.707 112.691 610.502 112.691Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M634.367 112.691C634.158 112.691 633.95 112.631 633.769 112.503L609.904 95.8707C609.43 95.5414 609.316 94.8893 609.645 94.4155C609.971 93.9416 610.623 93.824 611.097 94.1567L634.965 110.789C635.439 111.119 635.553 111.771 635.224 112.244C635.022 112.537 634.696 112.691 634.367 112.691Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M610.502 129.324C610.173 129.324 609.847 129.166 609.645 128.877C609.316 128.4 609.43 127.751 609.904 127.419L633.769 110.786C634.246 110.457 634.894 110.574 635.224 111.045C635.553 111.519 635.439 112.171 634.965 112.5L611.1 129.136C610.915 129.264 610.707 129.324 610.502 129.324Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M634.367 129.324C634.158 129.324 633.95 129.264 633.769 129.136L609.904 112.5C609.43 112.171 609.316 111.519 609.645 111.045C609.971 110.574 610.623 110.453 611.1 110.786L634.965 127.419C635.439 127.751 635.553 128.4 635.224 128.877C635.022 129.166 634.696 129.324 634.367 129.324Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M610.502 145.961C610.173 145.961 609.847 145.803 609.645 145.514C609.316 145.04 609.43 144.388 609.904 144.059L633.769 127.423C634.242 127.094 634.894 127.211 635.224 127.685C635.553 128.159 635.439 128.808 634.965 129.14L611.097 145.773C610.915 145.9 610.707 145.961 610.502 145.961Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M634.367 145.961C634.158 145.961 633.95 145.9 633.769 145.773L609.904 129.14C609.43 128.808 609.316 128.159 609.645 127.685C609.971 127.211 610.623 127.094 611.097 127.423L634.965 144.059C635.439 144.388 635.553 145.04 635.224 145.514C635.022 145.803 634.696 145.961 634.367 145.961Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M610.502 162.594C610.173 162.594 609.847 162.439 609.645 162.147C609.316 161.673 609.43 161.021 609.904 160.692L633.769 144.059C634.246 143.726 634.894 143.844 635.224 144.318C635.553 144.792 635.439 145.444 634.965 145.773L611.1 162.406C610.915 162.533 610.707 162.594 610.502 162.594Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M634.367 162.594C634.158 162.594 633.95 162.533 633.769 162.406L609.904 145.773C609.43 145.444 609.316 144.792 609.645 144.318C609.971 143.844 610.623 143.726 611.1 144.059L634.965 160.692C635.439 161.021 635.553 161.673 635.224 162.147C635.022 162.439 634.696 162.594 634.367 162.594Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M610.502 179.227C610.173 179.227 609.847 179.072 609.645 178.78C609.316 178.306 609.43 177.657 609.904 177.324L633.769 160.692C634.242 160.363 634.894 160.48 635.224 160.951C635.553 161.425 635.439 162.077 634.965 162.406L611.097 179.042C610.915 179.166 610.707 179.227 610.502 179.227Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M634.367 179.227C634.158 179.227 633.95 179.166 633.769 179.042L609.904 162.406C609.43 162.077 609.316 161.425 609.645 160.951C609.971 160.477 610.623 160.359 611.097 160.692L634.965 177.324C635.439 177.657 635.553 178.306 635.224 178.78C635.022 179.072 634.696 179.227 634.367 179.227Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M610.502 195.855C610.173 195.855 609.847 195.698 609.645 195.408C609.316 194.935 609.43 194.283 609.904 193.953L633.769 177.317C634.246 176.988 634.894 177.106 635.224 177.58C635.553 178.05 635.439 178.702 634.965 179.035L611.1 195.667C610.915 195.795 610.707 195.855 610.502 195.855Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M634.367 195.855C634.158 195.855 633.95 195.795 633.769 195.667L609.904 179.035C609.43 178.702 609.316 178.05 609.645 177.58C609.971 177.106 610.623 176.988 611.1 177.317L634.965 193.953C635.439 194.283 635.553 194.935 635.224 195.408C635.022 195.698 634.696 195.855 634.367 195.855Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M610.502 212.492C610.173 212.492 609.847 212.338 609.645 212.045C609.316 211.571 609.43 210.919 609.904 210.59L633.769 193.958C634.242 193.625 634.894 193.742 635.224 194.216C635.553 194.69 635.439 195.342 634.965 195.671L611.097 212.304C610.915 212.432 610.707 212.492 610.502 212.492Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M634.367 212.492C634.158 212.492 633.95 212.432 633.769 212.304L609.904 195.671C609.43 195.342 609.316 194.69 609.645 194.216C609.971 193.742 610.623 193.625 611.097 193.958L634.965 210.59C635.439 210.919 635.553 211.571 635.224 212.045C635.022 212.338 634.696 212.492 634.367 212.492Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M610.502 229.121C610.173 229.121 609.847 228.966 609.645 228.674C609.316 228.2 609.43 227.548 609.904 227.219L633.769 210.586C634.246 210.254 634.894 210.371 635.224 210.845C635.553 211.319 635.439 211.971 634.965 212.3L611.1 228.933C610.915 229.061 610.707 229.121 610.502 229.121Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M634.367 229.121C634.158 229.121 633.95 229.061 633.769 228.933L609.904 212.3C609.43 211.971 609.316 211.319 609.645 210.845C609.971 210.371 610.623 210.254 611.1 210.586L634.965 227.219C635.439 227.548 635.553 228.2 635.224 228.674C635.022 228.966 634.696 229.121 634.367 229.121Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M604.769 261.016C604.514 261.016 604.258 260.925 604.057 260.737C603.633 260.343 603.609 259.681 604.003 259.261L633.608 227.368C634.001 226.944 634.663 226.921 635.087 227.314C635.51 227.707 635.533 228.369 635.14 228.789L605.532 260.683C605.327 260.905 605.048 261.016 604.769 261.016Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M639.929 261.016C639.65 261.016 639.368 260.901 639.163 260.68L609.733 228.789C609.343 228.366 609.37 227.704 609.793 227.31C610.217 226.921 610.879 226.947 611.269 227.371L640.699 259.261C641.089 259.685 641.065 260.347 640.638 260.74C640.44 260.925 640.185 261.016 639.929 261.016Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M597.657 300.52C597.378 300.52 597.099 300.409 596.894 300.19C596.5 299.767 596.524 299.105 596.944 298.711L639.226 259.209C639.646 258.816 640.312 258.836 640.705 259.259C641.098 259.679 641.074 260.341 640.654 260.735L598.372 300.237C598.171 300.429 597.915 300.52 597.657 300.52Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M647.226 300.52C646.97 300.52 646.715 300.429 646.513 300.241L604.057 260.738C603.633 260.345 603.609 259.683 604.003 259.259C604.396 258.836 605.058 258.816 605.481 259.206L647.938 298.708C648.362 299.105 648.385 299.763 647.992 300.187C647.787 300.409 647.505 300.52 647.226 300.52Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M592.88 342.199H652.013L622.445 319.675L592.88 342.199ZM655.112 344.289H589.782C589.335 344.289 588.935 344.003 588.794 343.577C588.649 343.153 588.794 342.686 589.15 342.414L620.721 318.361L597.028 300.31C596.567 299.96 596.48 299.302 596.829 298.845C597.179 298.384 597.834 298.293 598.295 298.646L622.445 317.047L646.596 298.646C647.06 298.293 647.712 298.384 648.064 298.845C648.414 299.302 648.323 299.96 647.866 300.31L624.169 318.361L655.744 342.414C656.1 342.686 656.245 343.153 656.1 343.577C655.959 344.003 655.559 344.289 655.112 344.289Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M605.757 462.738C605.499 462.738 605.237 462.641 605.035 462.449L573.198 432.048C572.889 431.752 572.792 431.298 572.95 430.902C573.108 430.505 573.494 430.246 573.921 430.246H670.95C671.377 430.246 671.763 430.505 671.921 430.902C672.079 431.298 671.982 431.752 671.672 432.048L639.832 462.449C639.416 462.846 638.757 462.832 638.354 462.416C637.957 461.996 637.974 461.337 638.391 460.937L668.342 432.337H576.529L606.477 460.937C606.897 461.337 606.91 461.996 606.514 462.416C606.305 462.631 606.033 462.738 605.757 462.738Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M662.322 384.383H582.557C581.979 384.383 581.512 383.916 581.512 383.338C581.512 382.76 581.979 382.292 582.557 382.292H662.322C662.9 382.292 663.367 382.76 663.367 383.338C663.367 383.916 662.9 384.383 662.322 384.383Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M590.166 491.172C589.89 491.172 589.615 491.064 589.41 490.849L566.835 467.193C566.439 466.776 566.452 466.114 566.869 465.717C567.289 465.317 567.948 465.331 568.348 465.751L590.922 489.407C591.319 489.824 591.305 490.486 590.888 490.886C590.687 491.078 590.425 491.172 590.166 491.172Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M592.599 229.129C592.494 229.129 592.39 229.115 592.289 229.082L576.958 224.336V228.08C576.958 228.658 576.49 229.126 575.912 229.126C575.334 229.126 574.867 228.658 574.867 228.08V222.918C574.867 222.589 575.025 222.276 575.291 222.078C575.556 221.88 575.906 221.823 576.222 221.92L591.553 226.665V217.386C591.553 217.01 591.755 216.664 592.084 216.476C592.41 216.291 592.81 216.294 593.133 216.489L611.043 227.183C611.54 227.479 611.701 228.121 611.406 228.618C611.106 229.112 610.465 229.273 609.971 228.978L593.644 219.228V228.084C593.644 228.416 593.486 228.729 593.22 228.927C593.039 229.058 592.82 229.129 592.599 229.129Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M652.287 229.129C652.069 229.129 651.851 229.058 651.669 228.927C651.404 228.729 651.242 228.416 651.242 228.084V219.228L634.919 228.978C634.422 229.273 633.78 229.112 633.484 228.618C633.188 228.121 633.349 227.479 633.847 227.183L651.753 216.489C652.076 216.294 652.479 216.291 652.805 216.476C653.131 216.664 653.333 217.01 653.333 217.386V226.665L668.668 221.92C668.987 221.823 669.333 221.883 669.599 222.078C669.864 222.276 670.022 222.589 670.022 222.918V228.08C670.022 228.658 669.555 229.126 668.977 229.126C668.399 229.126 667.932 228.658 667.932 228.08V224.336L652.6 229.082C652.496 229.115 652.392 229.129 652.287 229.129Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M652.287 96.0586C652.069 96.0586 651.851 95.988 651.669 95.8536C651.404 95.6587 651.242 95.3461 651.242 95.0134V86.1578L634.919 95.9074C634.422 96.2031 633.78 96.0418 633.484 95.5477C633.188 95.0504 633.349 94.4084 633.847 94.1127L651.753 83.4187C652.076 83.2238 652.479 83.2204 652.805 83.4053C653.131 83.5935 653.333 83.9396 653.333 84.316V93.5952L668.668 88.8497C668.987 88.7489 669.333 88.8094 669.599 89.0077C669.864 89.206 670.022 89.5152 670.022 89.8479V95.01C670.022 95.5881 669.555 96.0552 668.977 96.0552C668.399 96.0552 667.932 95.5881 667.932 95.01V91.2661L652.6 96.0115C652.496 96.0451 652.392 96.0586 652.287 96.0586Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M592.599 96.0586C592.494 96.0586 592.39 96.0451 592.289 96.0115L576.958 91.2661V95.01C576.958 95.5881 576.49 96.0552 575.912 96.0552C575.334 96.0552 574.867 95.5881 574.867 95.01V89.8479C574.867 89.5152 575.025 89.206 575.291 89.0077C575.556 88.8094 575.906 88.7523 576.222 88.8497L591.553 93.5952V84.316C591.553 83.9396 591.755 83.5935 592.084 83.4053C592.41 83.2204 592.81 83.2238 593.133 83.4187L611.043 94.1127C611.54 94.4084 611.701 95.0504 611.406 95.5477C611.106 96.0418 610.465 96.2031 609.971 95.9074L593.644 86.1578V95.0134C593.644 95.3461 593.486 95.6587 593.22 95.8536C593.039 95.988 592.82 96.0586 592.599 96.0586Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M652.888 70.7968C652.746 70.7968 652.609 70.7699 652.474 70.7128L633.963 62.7007C633.435 62.4721 633.194 61.8538 633.422 61.3261C633.651 60.7985 634.259 60.5498 634.797 60.7817L651.842 68.1619V61.7428C651.842 61.1648 652.31 60.6943 652.888 60.6943C653.466 60.6943 653.933 61.1648 653.933 61.7428V69.7516C653.933 70.1045 653.758 70.4338 653.462 70.6254C653.291 70.7397 653.089 70.7968 652.888 70.7968Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M591.998 70.7969C591.8 70.7969 591.598 70.7398 591.427 70.6255C591.131 70.4339 590.953 70.1046 590.953 69.7517V61.7429C590.953 61.1649 591.42 60.6944 591.998 60.6944C592.576 60.6944 593.044 61.1649 593.044 61.7429V68.162L610.093 60.7818C610.627 60.5499 611.239 60.7952 611.467 61.3262C611.696 61.8539 611.454 62.4722 610.923 62.7007L592.415 70.7129C592.281 70.77 592.139 70.7969 591.998 70.7969Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M610.51 179.227C610.302 179.227 610.09 179.166 609.905 179.032L591.387 165.8V178.138C591.387 178.47 591.229 178.78 590.964 178.978C590.698 179.176 590.352 179.233 590.036 179.139L567.969 172.421V178.138C567.969 178.716 567.502 179.183 566.924 179.183C566.346 179.183 565.879 178.716 565.879 178.138V171.009C565.879 170.68 566.037 170.368 566.302 170.169C566.568 169.974 566.911 169.914 567.23 170.011L589.297 176.726V163.767C589.297 163.377 589.515 163.018 589.865 162.836C590.211 162.658 590.628 162.688 590.947 162.917L611.118 177.331C611.589 177.667 611.7 178.323 611.364 178.79C611.159 179.075 610.839 179.227 610.51 179.227Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M634.374 179.227C634.048 179.227 633.729 179.075 633.524 178.79C633.188 178.323 633.295 177.667 633.766 177.331L653.937 162.917C654.256 162.688 654.676 162.658 655.023 162.836C655.372 163.018 655.591 163.377 655.591 163.767V176.726L677.657 170.011C677.973 169.914 678.32 169.974 678.585 170.169C678.851 170.368 679.008 170.68 679.008 171.009V178.138C679.008 178.716 678.538 179.183 677.963 179.183C677.385 179.183 676.918 178.716 676.918 178.138V172.421L654.851 179.139C654.532 179.233 654.192 179.176 653.924 178.978C653.658 178.78 653.5 178.47 653.5 178.138V165.8L634.982 179.032C634.797 179.166 634.586 179.227 634.374 179.227Z",
    fill: "#93ACBF",
    fillOpacity: 0.51
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M753.693 78.5729C750.121 74.967 745.361 72.9694 740.295 72.9454C735.226 72.9214 730.45 74.8739 726.844 78.4458L724.925 76.5087C729.046 72.4264 734.509 70.1919 740.308 70.2194C746.103 70.2468 751.544 72.5329 755.63 76.654L753.693 78.5729Z",
    fill: "#BBE2FF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M764.904 67.4167C751.414 53.8018 729.364 53.6974 715.749 67.184L713.83 65.2468C728.515 50.7001 752.294 50.8127 766.841 65.4977L764.904 67.4167Z",
    fill: "#BBE2FF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M775.713 56.7213C756.318 37.1425 724.61 36.9925 705.031 56.3868L703.112 54.4496C713.121 44.535 726.383 39.1095 740.454 39.1761C754.525 39.2427 767.732 44.7935 777.65 54.8024L775.713 56.7213Z",
    fill: "#BBE2FF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M714.287 536H155.714C152.558 536 150 533.775 150 531.032V529.971C150 527.225 152.558 525 155.714 525H714.287C717.441 525 720 527.225 720 529.971V531.032C720 533.775 717.441 536 714.287 536Z",
    fill: "#21AAE9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M293.101 126.034C293.101 137.365 283.922 146.543 272.607 146.543H205.15C196.231 146.543 189 139.313 189 130.393C189 121.475 196.231 114.245 205.15 114.245C206.766 114.245 208.325 114.474 209.797 114.921C212.482 109.755 217.894 106.233 224.114 106.233C224.879 106.233 225.615 106.293 226.351 106.393C229.642 96.2906 239.139 89.0007 250.338 89.0007C261.234 89.0007 270.515 95.9011 274.051 105.585C284.687 106.321 293.101 115.196 293.101 126.034Z",
    fill: "#006AB3"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M237.544 128.478L226.385 114.538L215.227 128.478H221.446V138.488H231.325V128.478H237.544Z",
    fill: "#BBDBF3"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M244.551 124.546L255.71 138.488L266.868 124.546H260.649V114.538H250.77V124.546H244.551Z",
    fill: "#BBDBF3"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M279.935 101.453C279.935 106.646 275.725 110.855 270.531 110.855C265.338 110.855 261.129 106.646 261.129 101.453C261.129 96.2595 265.338 92.0492 270.531 92.0492C275.725 92.0492 279.935 96.2595 279.935 101.453Z",
    fill: "#2599E8"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M203.637 119.425C203.637 123.304 200.492 126.449 196.613 126.449C192.734 126.449 189.59 123.304 189.59 119.425C189.59 115.546 192.734 112.402 196.613 112.402C200.492 112.402 203.637 115.546 203.637 119.425Z",
    fill: "#2599E8"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M232.747 146.927C232.747 148.626 231.369 150.004 229.67 150.004C227.971 150.004 226.594 148.626 226.594 146.927C226.594 145.228 227.971 143.851 229.67 143.851C231.369 143.851 232.747 145.228 232.747 146.927Z",
    fill: "#2599E8"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M538.466 143.466H381.731V136.351C381.731 130.246 386.693 125.282 392.801 125.282H527.397C533.501 125.282 538.466 130.246 538.466 136.351V143.466ZM527.397 97.8386H392.801C371.46 97.8386 354 115.298 354 136.617V449.292C354 470.63 371.46 488.09 392.801 488.09H527.397C548.735 488.09 566.197 470.63 566.197 449.292V136.617C566.197 115.298 548.735 97.8386 527.397 97.8386Z",
    fill: "#586773"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M538.468 143.465H381.733V136.35C381.733 130.245 386.695 125.28 392.802 125.28H527.398C533.503 125.28 538.468 130.245 538.468 136.35V143.465ZM527.398 111.418H392.802C379.051 111.418 367.867 122.601 367.867 136.35V449.006C367.867 462.754 379.051 473.957 392.802 473.957H527.398C541.15 473.957 552.352 462.754 552.352 449.006V136.35C552.352 122.601 541.15 111.418 527.398 111.418Z",
    fill: "#E5F0F8"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M538.466 136.35V143.465H381.73V136.35C381.73 130.245 386.692 125.281 392.8 125.281H527.396C533.501 125.281 538.466 130.245 538.466 136.35Z",
    fill: "#BBDBF3"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M538.466 143.47V449.011C538.466 455.116 533.501 460.078 527.396 460.078H392.8C386.692 460.078 381.73 455.116 381.73 449.011V143.47H538.466Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M401.471 134.374C401.471 136.868 399.449 138.891 396.954 138.891C394.46 138.891 392.438 136.868 392.438 134.374C392.438 131.876 394.46 129.854 396.954 129.854C399.449 129.854 401.471 131.876 401.471 134.374Z",
    fill: "#40A87B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M414.178 134.374C414.178 136.868 412.156 138.891 409.661 138.891C407.167 138.891 405.145 136.868 405.145 134.374C405.145 131.876 407.167 129.854 409.661 129.854C412.156 129.854 414.178 131.876 414.178 134.374Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M426.904 134.374C426.904 136.868 424.879 138.891 422.384 138.891C419.889 138.891 417.867 136.868 417.867 134.374C417.867 131.876 419.889 129.854 422.384 129.854C424.879 129.854 426.904 131.876 426.904 134.374Z",
    fill: "#F74242"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M400.901 295.336H390.754V203.579H400.901V295.336Z",
    fill: "#BBDBF3"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M422.329 295.336H412.18V203.579H422.329V295.336Z",
    fill: "#BBDBF3"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M422.329 295.336H412.18V244.595H422.329V295.336Z",
    fill: "#6ADB6A"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M443.744 295.336H433.598V203.579H443.744V295.336Z",
    fill: "#BBDBF3"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M443.744 295.336H433.598V226.837H443.744V295.336Z",
    fill: "#6ADB6A"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M465.173 295.336H455.023V203.579H465.173V295.336Z",
    fill: "#BBDBF3"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M465.173 295.336H455.023V257.915H465.173V295.336Z",
    fill: "#6ADB6A"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M486.596 295.336H476.449V203.579H486.596V295.336Z",
    fill: "#BBDBF3"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M486.596 295.336H476.449V217.955H486.596V295.336Z",
    fill: "#6ADB6A"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M508.022 295.336H497.875V203.579H508.022V295.336Z",
    fill: "#BBDBF3"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M508.022 295.336H497.875V256.316H508.022V295.336Z",
    fill: "#6ADB6A"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M529.442 295.336H519.293V203.579H529.442V295.336Z",
    fill: "#BBDBF3"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M529.442 295.336H519.293V269.752H529.442V295.336Z",
    fill: "#6ADB6A"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M400.901 295.336H390.754V268.303H400.901V295.336Z",
    fill: "#6ADB6A"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M444.725 310.74C416.992 317.618 396.43 342.667 396.43 372.529C396.43 387.621 401.693 401.479 410.469 412.391L460.1 372.529L444.725 310.74Z",
    fill: "#6ADB6A"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M498.215 321.526C487.588 313.569 474.39 308.857 460.093 308.857C454.792 308.857 449.645 309.514 444.719 310.738L460.093 372.527L498.215 321.526Z",
    fill: "#F74242"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M523.719 370.608C523.124 350.529 513.252 332.78 498.219 321.526L460.098 372.527L523.719 370.608Z",
    fill: "#F9E181"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M523.719 370.61L460.098 372.529L505.28 417.383C516.705 405.874 523.768 390.027 523.768 372.529C523.768 371.886 523.738 371.248 523.719 370.61Z",
    fill: "#088CFC"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M479.729 433.102C489.487 429.939 498.219 424.494 505.28 417.382L460.098 372.529L479.729 433.102Z",
    fill: "#2EC6FC"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M410.465 412.383C422.134 426.894 440.025 436.191 460.096 436.191C466.947 436.191 473.541 435.095 479.727 433.094L460.096 372.521L410.465 412.383Z",
    fill: "#40A87B"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M419.094 153.078H430.165V189.633H419.094V153.078Z",
    fill: "#21AAE9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M454.114 162.229C448.797 162.229 445.345 166.284 445.345 171.38C445.345 176.477 448.797 180.532 454.114 180.532C459.43 180.532 462.882 176.477 462.882 171.38C462.882 166.284 459.43 162.229 454.114 162.229ZM454.114 152.472C465.403 152.472 474.117 160.145 474.117 171.38C474.117 182.616 465.403 190.289 454.114 190.289C442.823 190.289 434.109 182.616 434.109 171.38C434.109 160.145 442.823 152.472 454.114 152.472Z",
    fill: "#21AAE9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M484.807 162.722H474.996V153.078H505.633V162.722H495.877V189.633H484.807V162.722Z",
    fill: "#21AAE9"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M454.073 173.743C453.196 173.743 452.484 174.453 452.484 175.331C452.484 176.209 453.196 176.922 454.073 176.922C454.951 176.922 455.662 176.209 455.662 175.331C455.662 174.453 454.951 173.743 454.073 173.743Z",
    fill: "#21AAE9"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M454.07 171.376C452.661 171.376 451.409 172.05 450.613 173.092C450.463 173.289 450.481 173.568 450.656 173.746L450.711 173.799C450.928 174.016 451.277 173.976 451.464 173.733C452.065 172.951 453.009 172.441 454.07 172.441C455.187 172.441 456.174 173.003 456.768 173.858C456.94 174.108 457.299 174.131 457.513 173.917L457.571 173.861C457.742 173.69 457.763 173.417 457.622 173.22C456.833 172.106 455.537 171.376 454.07 171.376Z",
    fill: "#21AAE9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M454.071 166.228C451.642 166.228 449.466 167.313 447.985 169.015C447.819 169.206 447.838 169.499 448.018 169.676L448.077 169.735C448.278 169.936 448.606 169.929 448.792 169.712C450.077 168.236 451.964 167.296 454.071 167.296C456.226 167.296 458.153 168.279 459.438 169.814C459.623 170.034 459.956 170.047 460.159 169.844L460.217 169.788C460.394 169.61 460.415 169.324 460.254 169.13C458.773 167.362 456.555 166.228 454.071 166.228Z",
    fill: "#21AAE9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M454.079 168.744C452.163 168.744 450.451 169.615 449.308 170.98C449.141 171.18 449.147 171.469 449.33 171.653L449.386 171.709C449.591 171.916 449.925 171.897 450.111 171.673C451.059 170.536 452.485 169.813 454.079 169.813C455.719 169.813 457.179 170.582 458.125 171.778C458.308 172.012 458.649 172.035 458.858 171.824L458.92 171.762C459.099 171.584 459.111 171.298 458.953 171.101C457.811 169.665 456.051 168.744 454.079 168.744Z",
    fill: "#21AAE9"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M548.671 293.369C548.225 294.166 551.834 298.354 555.293 300.438C558.221 302.208 565.412 305.56 567.536 306.531L573.41 297.365C572.357 296.483 571.227 295.475 570.367 294.485C568.232 292.075 561.677 286.175 560.829 287.135C559.981 288.079 563.663 293.031 562.983 293.139C562.298 293.247 558.753 290.245 557.35 288.849C555.929 287.451 553.396 283.969 552.25 284.144C551.093 284.318 550.922 286.022 550.922 286.022C550.922 286.022 550.104 284.579 549.296 285.252C548.485 285.929 549.196 288.492 549.196 288.492C549.196 288.492 548.839 287.644 548.132 288.608C547.425 289.586 549.787 293.035 549.787 293.035C549.787 293.035 549.107 292.558 548.671 293.369Z",
    fill: "#FDAE97"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M640.832 238.999C648.451 239.661 655.065 246.134 655.158 255.382C655.251 264.627 656.929 269.385 662.516 268.313C662.516 268.313 646.862 277.39 626.227 269.381C626.227 269.381 628.816 266.312 629.177 259.37C629.538 252.425 640.832 238.999 640.832 238.999Z",
    fill: "#322A28"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M600.771 333.475C605.622 336.086 611.734 334.252 614.345 329.397L633.98 292.914C636.595 288.059 634.761 281.951 629.907 279.336C625.052 276.724 618.943 278.558 616.332 283.413L596.693 319.896C594.082 324.751 595.916 330.859 600.771 333.475Z",
    fill: "#F9E181"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M645.401 345.616C651.964 354.206 654.438 372.017 650.252 391.206C646.067 410.394 644.654 423.006 644.654 423.006C643.564 431.889 635.48 438.206 626.6 437.116C617.716 436.022 611.399 427.938 612.489 419.058L619.163 345.616H645.401Z",
    fill: "#192C4A"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M646.838 275.184L664.378 283.126C664.378 283.126 660.48 328.278 660.074 333.218C659.672 338.158 661.183 345.617 661.183 345.617H619.153C619.153 345.617 619.655 321.425 616.835 314.673C614.923 310.097 613.61 307.315 614.718 302.073C615.827 296.831 623.937 287.565 622.627 278.491L631.779 275.563L646.838 275.184Z",
    fill: "#F9E181"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M678.456 340.76C683.635 338.863 686.317 333.078 684.423 327.903L670.179 288.994C668.282 283.816 662.497 281.134 657.319 283.027C652.144 284.925 649.458 290.709 651.355 295.884L665.6 334.793C667.497 339.968 673.282 342.654 678.456 340.76Z",
    fill: "#F9E181"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M629.671 249.012C629.671 249.012 627.287 243.138 633.023 241.363L629.671 249.012Z",
    fill: "#332B27"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M631.789 255.147V275.552C631.789 275.552 632.202 280.027 637.514 280.421C642.101 280.771 645.029 277.75 646.264 276.136L646.911 275.187L646.926 275.172L644.761 255.147H631.789Z",
    fill: "#FDAE97"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M631.793 273.23L640.836 263.398L631.789 266.798L631.793 273.23Z",
    fill: "#E89780"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M640.764 265.574C636.538 268.07 631.549 268.066 628.543 266.043C625.53 264.03 626.025 259.391 626.921 256.449C626.925 256.437 626.925 256.437 626.929 256.426C627.115 255.816 627.379 254.96 627.677 253.993C628.826 250.188 630.526 244.555 630.526 244.555C631.27 241.583 639.793 234.887 647.866 243.618C655.931 252.36 644.994 263.081 640.764 265.574Z",
    fill: "#FDAE97"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M630.793 243.353C630.793 243.353 630.901 246.921 635.897 249.302C640.893 251.686 645.636 255.328 645.037 260.596C644.442 265.864 646.246 268.836 646.246 268.836C646.246 268.836 646.99 262.27 650.301 256.712C651.585 254.558 652.708 250.008 650.577 246.087C647.214 239.897 638.523 235.199 630.793 243.353Z",
    fill: "#322A28"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M644.187 259.464C643.112 261.053 642.807 262.18 644.053 263.025C645.3 263.869 647.413 263.668 648.488 262.08C649.563 260.491 649.422 258.523 648.175 257.679C646.929 256.834 645.259 257.876 644.187 259.464Z",
    fill: "#FDAE97"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M646.988 260.645C645.943 260.135 645.031 260.592 645.031 260.592C645.753 258.781 647.929 259.514 647.929 259.514",
    stroke: "#E89780"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M636.33 254.759C636.129 255.473 635.593 255.946 635.132 255.819C634.671 255.689 634.459 255.008 634.656 254.294C634.853 253.58 635.389 253.107 635.85 253.234C636.311 253.364 636.527 254.045 636.33 254.759Z",
    fill: "#2C3447"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M630.53 252.537C630.348 253.196 629.853 253.635 629.425 253.516C628.998 253.397 628.804 252.768 628.986 252.109C629.169 251.451 629.664 251.012 630.088 251.131C630.515 251.246 630.713 251.879 630.53 252.537Z",
    fill: "#2C3447"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M606.676 506.57H635.146L644.919 422.886L645.045 420.974C645.045 411.874 637.549 404.542 628.39 404.817C620.131 405.056 613.208 411.774 612.721 420.033L606.676 506.57Z",
    fill: "#192C4A"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M638.775 253.629C638.775 253.629 637.837 251.453 635.988 251.635",
    stroke: "#2C3447"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M631.333 249.997C631.333 249.997 630.343 249.514 628.922 250.336",
    stroke: "#2C3447"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M658.666 506.57H685.834L677.211 420.133L677.185 419.832C676.612 411.436 669.603 404.803 661.054 404.803C652.119 404.803 644.887 412.038 644.887 420.974C644.887 421.472 644.913 421.96 644.961 422.436L658.666 506.57Z",
    fill: "#192C4A"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M564.781 310.842L598.028 331.879L599.996 333.513C604.006 336.292 609.88 334.844 613.039 330.291C616.193 325.738 615.479 319.741 611.469 316.962L574.23 296.088L573.408 297.364L567.534 306.531L564.781 310.842Z",
    fill: "#F9E181"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M632.934 253.075C632.934 253.075 631.867 256.587 629.672 256.442C629.672 256.442 630.167 257.227 630.926 257.703",
    stroke: "#2C3447"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M632.344 345.618L632.723 347.973L644.918 422.483C645.852 431.389 653.824 437.84 662.726 436.906C671.617 435.976 678.086 428.004 677.153 419.098C677.153 419.098 675.679 406.494 675.445 386.848C675.252 371.633 671.807 359.36 666.379 351.421C664.798 349.111 663.061 347.166 661.193 345.618H632.344Z",
    fill: "#192C4A"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M629.758 260.55C629.758 260.55 631.793 262.16 634.159 260.081",
    stroke: "#2C3447"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M639.785 257.884C639.807 258.654 638.598 259.316 637.084 259.357C635.573 259.398 634.327 258.807 634.305 258.037C634.286 257.263 635.495 256.604 637.009 256.564C638.52 256.523 639.766 257.114 639.785 257.884Z",
    fill: "#E89780"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M628.518 256.062C628.276 256.471 627.658 256.587 626.922 256.427C627.108 255.817 627.372 254.961 627.67 253.994C628.462 254.716 628.838 255.549 628.518 256.062Z",
    fill: "#E89780"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M643.46 263.03C643.285 263.684 643.675 264.362 644.334 264.536C644.992 264.711 645.666 264.321 645.844 263.666C646.019 263.007 645.629 262.33 644.97 262.156C644.312 261.981 643.638 262.371 643.46 263.03Z",
    stroke: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M691.299 524.93H670.325L667.605 520.785L667.665 524.93H663.048L663.461 512.958L662.449 506.567H679.532L679.595 512.958L691.299 524.93Z",
    fill: "#FDAE97"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M631.145 275.468L632.201 296.918L646.263 276.137C645.028 277.752 642.1 280.773 637.513 280.423C632.201 280.029 631.145 275.468 631.145 275.468Z",
    fill: "#E5F0F8"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M646.788 274.018L636.305 280.257L638.522 284.137L648.269 275.83L646.788 274.018Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M631.791 274.905L636.311 280.247L633.58 283.539L630.734 275.887L631.791 274.905Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M575.433 341.06L631.894 343.426L618.933 300.529L562.469 298.159L575.433 341.06Z",
    fill: "#A5BBD6"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M631.359 341.336L650.506 325.782L595.895 323.49L574.895 338.97L631.359 341.336Z",
    fill: "#89A5C7"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M577.961 339.896L634.421 342.266L621.46 299.365L565 296.999L577.961 339.896Z",
    fill: "#A0DDF9"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_116_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_116_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 597,
    y: 317,
    width: 2,
    height: 2
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M597.99 317.143H599V318.154H597.99V317.143Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_116_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_116_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 597,
    y: 317,
    width: 2,
    height: 2
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M598.615 317.194C598.563 317.181 598.511 317.177 598.457 317.181C598.404 317.185 598.353 317.196 598.303 317.216C598.254 317.235 598.21 317.261 598.169 317.294C598.128 317.327 598.095 317.365 598.067 317.408C598.06 317.425 598.05 317.439 598.042 317.454C598.028 317.479 598.019 317.506 598.013 317.534C598.005 317.564 598.001 317.594 597.999 317.625C597.997 317.656 597.999 317.686 598.004 317.717C598.008 317.747 598.016 317.777 598.027 317.806C598.038 317.835 598.052 317.863 598.069 317.889C598.085 317.916 598.105 317.94 598.127 317.963C598.148 317.986 598.172 318.006 598.199 318.025C598.225 318.043 598.253 318.059 598.282 318.072C598.311 318.085 598.342 318.096 598.374 318.103C598.425 318.115 598.476 318.119 598.529 318.116C598.581 318.112 598.631 318.101 598.68 318.082C598.728 318.064 598.773 318.039 598.813 318.007C598.853 317.976 598.888 317.939 598.916 317.898L598.953 317.829H598.954C598.964 317.807 598.972 317.784 598.977 317.761C598.985 317.731 598.99 317.701 598.991 317.67C598.993 317.64 598.991 317.609 598.986 317.579C598.981 317.548 598.973 317.519 598.962 317.49C598.951 317.461 598.937 317.433 598.92 317.407C598.903 317.381 598.884 317.356 598.862 317.334C598.84 317.311 598.816 317.29 598.79 317.272C598.764 317.253 598.736 317.238 598.706 317.224C598.677 317.211 598.647 317.201 598.615 317.194Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_116_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.038 316.99L597.799 318.08L598.952 318.305L599.191 317.216L598.038 316.99Z",
    fill: "url(#paint0_linear_116_2)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_116_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 597,
    y: 321,
    width: 2,
    height: 2
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M597.893 321.923H598.971V322.934H597.893V321.923Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_116_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_116_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 597,
    y: 321,
    width: 2,
    height: 2
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M598.581 321.978C598.529 321.966 598.476 321.962 598.423 321.966C598.37 321.969 598.318 321.981 598.269 322C598.22 322.02 598.175 322.046 598.135 322.079C598.094 322.112 598.06 322.15 598.033 322.193L598.006 322.238C597.994 322.264 597.984 322.291 597.977 322.318C597.962 322.373 597.958 322.428 597.964 322.483C597.971 322.539 597.987 322.592 598.013 322.642C598.04 322.693 598.074 322.737 598.117 322.775C598.161 322.814 598.209 322.844 598.264 322.866C598.319 322.888 598.375 322.9 598.435 322.903C598.494 322.906 598.552 322.899 598.609 322.882C598.665 322.865 598.717 322.839 598.764 322.805C598.811 322.771 598.85 322.73 598.882 322.682C598.895 322.661 598.907 322.637 598.918 322.615H598.92C598.93 322.593 598.936 322.572 598.943 322.548C598.951 322.518 598.956 322.488 598.957 322.457C598.959 322.426 598.957 322.395 598.952 322.365C598.947 322.334 598.939 322.304 598.928 322.275C598.917 322.247 598.903 322.219 598.886 322.192C598.869 322.166 598.85 322.141 598.828 322.118C598.806 322.095 598.782 322.075 598.756 322.057C598.73 322.038 598.702 322.023 598.672 322.009C598.643 321.996 598.612 321.986 598.581 321.978Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_116_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.999 321.775L597.759 322.867L598.918 323.093L599.157 322.001L597.999 321.775Z",
    fill: "#2771E0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_116_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 589,
    y: 315,
    width: 9,
    height: 10
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M589 315H597.598V324.926H589V315Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_116_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_116_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 589,
    y: 314,
    width: 9,
    height: 11
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M597.13 323.154C597.061 323.14 596.991 323.141 596.922 323.155C596.853 323.169 596.79 323.196 596.733 323.236C596.539 323.366 596.335 323.48 596.122 323.577C595.908 323.675 595.687 323.755 595.459 323.817C595.231 323.88 594.999 323.924 594.763 323.95C594.527 323.976 594.29 323.983 594.053 323.971L593.986 323.968C593.791 323.955 593.598 323.93 593.407 323.893C591.106 323.443 589.628 321.319 590.104 319.15C590.581 316.98 592.832 315.584 595.131 316.034C595.695 316.143 596.213 316.352 596.686 316.66H596.688C596.716 316.685 596.747 316.706 596.781 316.724C596.826 316.746 596.874 316.763 596.924 316.773C596.979 316.783 597.035 316.785 597.091 316.778C597.148 316.77 597.201 316.754 597.252 316.73C597.302 316.706 597.348 316.674 597.387 316.635C597.426 316.597 597.458 316.553 597.482 316.504C597.505 316.456 597.52 316.405 597.525 316.351C597.531 316.298 597.527 316.246 597.513 316.193C597.5 316.141 597.478 316.093 597.448 316.047C597.417 316.002 597.379 315.963 597.335 315.93H597.333L597.3 315.908L597.292 315.903C596.698 315.509 596.047 315.243 595.336 315.104C592.492 314.549 589.709 316.272 589.118 318.957C588.528 321.641 590.357 324.266 593.202 324.823C593.555 324.892 593.912 324.926 594.272 324.926C594.633 324.926 594.989 324.892 595.342 324.822C595.695 324.753 596.036 324.65 596.367 324.515C596.697 324.379 597.009 324.213 597.304 324.017L597.313 324.011L597.335 323.995L597.344 323.989C597.437 323.918 597.496 323.827 597.521 323.716C597.528 323.686 597.532 323.655 597.532 323.624C597.532 323.592 597.529 323.561 597.523 323.531C597.517 323.5 597.507 323.47 597.495 323.441C597.482 323.412 597.467 323.385 597.449 323.359C597.431 323.333 597.41 323.308 597.387 323.286C597.364 323.264 597.338 323.244 597.311 323.226C597.284 323.209 597.255 323.194 597.224 323.182C597.194 323.169 597.162 323.16 597.13 323.154Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_116_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.351 313.402L586.911 324.518L597.181 326.525L599.621 315.408L589.351 313.402Z",
    fill: "url(#paint1_linear_116_2)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_116_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 590,
    y: 316,
    width: 7,
    height: 7
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M596.765 316.868H590.98V322.934H596.765V316.868Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_116_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_116_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 591,
    y: 316,
    width: 6,
    height: 7
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M595.089 322.795C594.826 322.865 594.558 322.901 594.285 322.905C594.011 322.909 593.742 322.879 593.477 322.817L593.365 322.788H593.363C593.304 322.772 593.246 322.755 593.189 322.736C593.131 322.717 593.075 322.696 593.018 322.674C592.962 322.652 592.906 322.628 592.852 322.603C592.797 322.578 592.743 322.551 592.689 322.523C592.636 322.495 592.584 322.466 592.533 322.435C592.481 322.404 592.431 322.372 592.381 322.338C592.332 322.304 592.283 322.27 592.236 322.233C592.189 322.197 592.142 322.16 592.098 322.121C592.052 322.082 592.009 322.042 591.966 322.001C591.923 321.96 591.882 321.918 591.842 321.874C591.802 321.831 591.763 321.787 591.726 321.741C591.689 321.696 591.653 321.649 591.618 321.602C591.584 321.554 591.551 321.506 591.519 321.457C591.488 321.408 591.457 321.358 591.429 321.307C591.401 321.256 591.373 321.205 591.348 321.152C591.323 321.1 591.299 321.047 591.277 320.994C591.255 320.94 591.234 320.886 591.215 320.831C591.197 320.776 591.179 320.721 591.164 320.666C591.148 320.61 591.134 320.554 591.122 320.498C591.11 320.441 591.1 320.385 591.091 320.328C591.082 320.271 591.076 320.214 591.071 320.156C591.065 320.099 591.062 320.042 591.06 319.984C591.059 319.927 591.059 319.87 591.061 319.812C591.062 319.755 591.066 319.697 591.071 319.64C591.076 319.583 591.084 319.526 591.092 319.468C591.101 319.412 591.112 319.355 591.124 319.299C591.136 319.242 591.15 319.186 591.166 319.131C591.181 319.075 591.198 319.02 591.218 318.965C591.237 318.911 591.257 318.857 591.28 318.803C591.302 318.75 591.326 318.697 591.351 318.645C591.377 318.592 591.404 318.541 591.432 318.49C591.461 318.439 591.491 318.39 591.523 318.34C591.555 318.291 591.588 318.243 591.622 318.196C591.657 318.148 591.693 318.102 591.731 318.057C591.768 318.011 591.807 317.967 591.847 317.924C591.887 317.88 591.929 317.838 591.971 317.797C592.014 317.756 592.058 317.716 592.103 317.678C592.148 317.639 592.195 317.602 592.242 317.566C592.29 317.529 592.338 317.495 592.387 317.461C592.437 317.428 592.487 317.395 592.539 317.365C592.591 317.334 592.643 317.305 592.696 317.277C592.749 317.249 592.803 317.222 592.858 317.197C592.913 317.172 592.969 317.149 593.025 317.127C593.081 317.105 593.139 317.085 593.196 317.065C593.253 317.046 593.312 317.029 593.37 317.013C593.429 316.998 593.488 316.984 593.548 316.971C593.607 316.959 593.667 316.948 593.727 316.938C593.787 316.929 593.847 316.921 593.908 316.915C593.968 316.909 594.029 316.905 594.09 316.902C594.151 316.899 594.212 316.898 594.273 316.899C594.334 316.899 594.395 316.901 594.456 316.905C594.516 316.909 594.577 316.915 594.637 316.922C594.698 316.929 594.758 316.938 594.818 316.948C594.878 316.959 594.938 316.971 594.997 316.984C595.056 316.998 595.115 317.013 595.173 317.03C595.231 317.047 595.289 317.065 595.346 317.085C595.403 317.105 595.46 317.127 595.516 317.15C595.572 317.173 595.627 317.197 595.681 317.223C595.735 317.249 595.789 317.277 595.842 317.306C595.894 317.334 595.946 317.365 595.997 317.397C596.048 317.428 596.098 317.461 596.147 317.496C596.195 317.53 596.243 317.566 596.29 317.603C596.336 317.64 596.382 317.678 596.426 317.717C596.471 317.757 596.514 317.798 596.556 317.839L596.638 317.927C596.65 317.94 596.659 317.954 596.668 317.968C596.7 318.022 596.721 318.078 596.732 318.139C596.742 318.199 596.741 318.259 596.729 318.319C596.717 318.379 596.694 318.435 596.66 318.487C596.627 318.539 596.584 318.585 596.534 318.622C596.483 318.66 596.426 318.688 596.365 318.707C596.303 318.726 596.24 318.734 596.175 318.731C596.11 318.729 596.048 318.715 595.989 318.692C595.929 318.667 595.876 318.635 595.828 318.593L595.778 318.54C595.692 318.453 595.598 318.374 595.496 318.303C595.395 318.232 595.287 318.17 595.174 318.117C595.06 318.065 594.943 318.022 594.821 317.989C594.7 317.956 594.576 317.934 594.451 317.922C594.325 317.91 594.199 317.909 594.073 317.918C593.947 317.928 593.823 317.948 593.7 317.979C593.578 318.009 593.46 318.05 593.345 318.1C593.231 318.151 593.122 318.211 593.019 318.28C592.916 318.349 592.82 318.426 592.732 318.511C592.644 318.597 592.564 318.689 592.494 318.788C592.423 318.886 592.362 318.99 592.311 319.099C592.26 319.209 592.22 319.321 592.19 319.437C592.161 319.553 592.142 319.671 592.136 319.79C592.128 319.909 592.132 320.027 592.148 320.146C592.164 320.264 592.19 320.38 592.228 320.494C592.266 320.608 592.314 320.718 592.373 320.823C592.431 320.929 592.499 321.029 592.577 321.123C592.654 321.217 592.74 321.304 592.834 321.384C592.929 321.463 593.03 321.534 593.137 321.596C593.245 321.659 593.358 321.712 593.476 321.755C593.593 321.798 593.715 321.831 593.839 321.854C593.963 321.877 594.088 321.889 594.214 321.89C594.341 321.892 594.466 321.883 594.591 321.863C594.716 321.843 594.837 321.813 594.956 321.772C595.22 321.684 595.454 321.55 595.66 321.372C595.662 321.372 595.662 321.372 595.662 321.37L595.707 321.332C595.731 321.312 595.756 321.295 595.784 321.279C595.84 321.249 595.899 321.228 595.962 321.217C596.025 321.207 596.089 321.207 596.152 321.217C596.216 321.228 596.275 321.249 596.33 321.28C596.386 321.311 596.434 321.349 596.474 321.396C596.515 321.444 596.545 321.496 596.566 321.553C596.587 321.611 596.596 321.67 596.595 321.731C596.593 321.791 596.58 321.85 596.556 321.906C596.532 321.963 596.499 322.013 596.455 322.058C596.437 322.079 596.416 322.098 596.393 322.114H596.391C596.016 322.44 595.582 322.667 595.089 322.795Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_116_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.43 318.206L595.506 314.686L599.37 321.601L592.295 325.121L588.43 318.206Z",
    fill: "url(#paint2_linear_116_2)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_116_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 592,
    y: 318,
    width: 6,
    height: 3
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M597.157 318.981H592.941V320.82H597.157V318.981Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_116_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_116_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 592,
    y: 319,
    width: 6,
    height: 2
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M592.996 319.779C593.003 319.73 593.014 319.681 593.03 319.634C593.046 319.586 593.066 319.54 593.089 319.496C593.113 319.451 593.141 319.409 593.173 319.369C593.204 319.329 593.239 319.292 593.277 319.257C593.316 319.223 593.357 319.192 593.4 319.164C593.444 319.136 593.49 319.111 593.538 319.091C593.586 319.07 593.636 319.053 593.687 319.04C593.738 319.028 593.79 319.019 593.843 319.015C593.895 319.01 593.948 319.01 594.001 319.014C594.054 319.018 594.105 319.026 594.157 319.038C594.208 319.05 594.258 319.067 594.306 319.087C594.355 319.107 594.401 319.131 594.445 319.158C594.489 319.186 594.53 319.216 594.569 319.25C594.607 319.285 594.643 319.322 594.675 319.361C594.707 319.401 594.735 319.443 594.759 319.487C594.784 319.531 594.804 319.577 594.821 319.625C595.006 319.723 595.26 319.783 595.544 319.783C595.787 319.783 596.011 319.738 596.186 319.663C596.231 319.59 596.292 319.534 596.37 319.493C596.408 319.473 596.448 319.457 596.491 319.446C596.516 319.441 596.542 319.437 596.569 319.435C596.64 319.429 596.71 319.437 596.778 319.459C596.846 319.481 596.906 319.516 596.958 319.563H596.96L596.997 319.601C597.016 319.622 597.033 319.644 597.047 319.668C597.063 319.695 597.076 319.723 597.086 319.752C597.097 319.782 597.104 319.812 597.108 319.842C597.112 319.873 597.113 319.904 597.11 319.934C597.108 319.965 597.103 319.995 597.094 320.025C597.085 320.055 597.074 320.084 597.059 320.111C597.044 320.139 597.027 320.165 597.007 320.189C596.987 320.213 596.964 320.236 596.94 320.256C596.915 320.276 596.888 320.294 596.86 320.309C596.769 320.357 596.672 320.377 596.569 320.367C596.542 320.365 596.516 320.361 596.491 320.354C596.411 320.335 596.34 320.299 596.279 320.247L596.223 320.191C596.223 320.19 596.222 320.189 596.221 320.189L596.186 320.14C596.011 320.063 595.787 320.018 595.544 320.018C595.26 320.018 595.006 320.078 594.821 320.178C594.802 320.229 594.779 320.279 594.75 320.327C594.722 320.375 594.689 320.419 594.652 320.461C594.615 320.503 594.574 320.542 594.53 320.577C594.485 320.611 594.437 320.642 594.387 320.669C594.336 320.695 594.283 320.717 594.229 320.735C594.173 320.752 594.118 320.764 594.06 320.772C594.003 320.78 593.945 320.782 593.887 320.78C593.83 320.777 593.773 320.77 593.716 320.758C593.66 320.745 593.605 320.728 593.552 320.706C593.499 320.684 593.448 320.658 593.4 320.627C593.352 320.596 593.308 320.562 593.267 320.524C593.226 320.485 593.188 320.443 593.156 320.399C593.123 320.354 593.094 320.306 593.071 320.256C593.047 320.207 593.028 320.155 593.014 320.102C593.001 320.049 592.992 319.995 592.989 319.94C592.986 319.886 592.988 319.832 592.996 319.777V319.779Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_116_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596.943 318.237L597.486 320.709L593.156 321.556L592.613 319.083L596.943 318.237Z",
    fill: "url(#paint3_linear_116_2)"
  }))))), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M563.577 297.27L562.469 298.159L618.933 300.529L631.894 343.426L632.999 342.537L620.038 299.636L563.577 297.27Z",
    fill: "#89A5C7"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M650.506 325.792L651.034 327.868L631.887 343.426L631.258 341.343L650.506 325.792Z",
    fill: "#586773"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M615.86 524.93L620.874 521.198L620.447 524.93H625.112L627.407 512.958L628.638 506.567H610.547L609.852 512.958L595.332 524.93H615.86Z",
    fill: "#FDAE97"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M679.598 512.958L691.301 524.93H670.327L667.608 520.785L667.667 524.93H663.051L663.464 512.958H679.598Z",
    fill: "#322A28"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M615.86 524.93L620.874 521.198L620.447 524.93H625.112L627.407 512.958H609.852L595.332 524.93H615.86Z",
    fill: "#322A28"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M608.583 330.844C607.764 331.678 608.642 333.143 608.642 333.143C608.642 333.143 607.117 332.474 606.886 333.493C606.663 334.442 608.464 335.941 608.698 336.134C608.527 336.052 607.947 335.844 607.965 336.882C607.973 338.024 611.563 339.296 611.901 339.412C611.771 339.434 611.112 339.534 611.231 340.357C611.369 341.275 616.76 342.473 620.774 342.079C624.159 341.74 631.886 340.104 634.196 339.613L633.586 328.776C632.172 328.709 630.587 328.56 629.289 328.274C626.123 327.615 617.344 326.826 617.239 328.102C617.128 329.364 623.043 331.131 622.559 331.622C622.079 332.109 617.444 331.834 615.487 331.566C613.508 331.287 609.386 330.015 608.583 330.844Z",
    fill: "#FDAE97"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M633.391 325.495L633.58 328.772L634.19 339.609L634.354 342.484L676.369 341.789C681.246 341.621 685.085 336.953 684.903 331.417C684.699 325.87 680.547 321.495 675.655 321.667L672.489 322.206L672.474 322.213L633.391 325.495Z",
    fill: "#F9E181"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M641.281 324.836L661.34 323.151L657.215 311.89",
    stroke: "#2C3447"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M660.594 342.051H669.712",
    stroke: "#2C3447"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M635.968 257.04C635.529 257.257 635.091 257.274 634.737 257.097C634.383 256.922 634.131 256.564 634.039 256.083C633.946 255.602 634.019 255.018 634.298 254.456C634.578 253.894 634.999 253.484 635.439 253.267C635.878 253.05 636.314 253.034 636.666 253.21H636.668C637.022 253.386 637.273 253.744 637.366 254.225C637.459 254.706 637.386 255.289 637.106 255.851C636.827 256.413 636.407 256.824 635.968 257.04ZM637.757 256.175C637.414 256.867 636.884 257.399 636.29 257.693C635.695 257.987 635.014 258.048 634.413 257.749C633.811 257.451 633.45 256.872 633.325 256.22C633.199 255.569 633.303 254.824 633.646 254.133C633.991 253.442 634.522 252.908 635.117 252.614C635.711 252.321 636.391 252.259 636.991 252.559C637.592 252.856 637.955 253.435 638.08 254.087C638.206 254.738 638.102 255.483 637.757 256.175Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M629.01 254.9C628.655 254.723 628.405 254.364 628.312 253.883C628.22 253.401 628.293 252.817 628.571 252.255C628.85 251.693 629.27 251.284 629.709 251.067C630.148 250.851 630.586 250.834 630.941 251.01C631.295 251.184 631.546 251.542 631.638 252.023C631.731 252.505 631.658 253.088 631.379 253.651C631.101 254.212 630.68 254.623 630.241 254.84C629.802 255.057 629.364 255.075 629.01 254.9ZM630.563 255.492C631.158 255.198 631.688 254.665 632.031 253.974C632.374 253.282 632.478 252.537 632.352 251.886C632.227 251.234 631.866 250.655 631.263 250.357C630.663 250.06 629.983 250.122 629.387 250.415C628.793 250.708 628.262 251.24 627.919 251.932C627.577 252.623 627.473 253.368 627.598 254.02C627.723 254.672 628.085 255.252 628.686 255.551L628.687 255.552C629.288 255.849 629.968 255.786 630.563 255.492Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M631.871 253.306L634.192 254.105L634.429 253.418L632.108 252.618L631.871 253.306Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M157 82C175.778 82 191 66.7777 191 48C191 29.2223 175.778 14 157 14C138.222 14 123 29.2223 123 48C123 66.7777 138.222 82 157 82Z",
    fill: "#21AAE9"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M152.012 39.9533C153.533 41.8911 153.103 44.4718 152.097 45.0856C151.126 45.676 148.193 45.1371 146.674 43.1998C145.155 41.263 145.661 38.6339 146.589 38.0686C147.52 37.5042 150.493 38.0166 152.012 39.9533Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M145.703 45.3125H151.972V38.0686H145.703V45.3125Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M163.568 51.359V55.0434C163.568 63.9233 150.548 63.7382 150.548 55.0434V51.359H141V66.3867H173.984V51.359H163.568Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M162.634 45.0609L162.121 44.7479L157.776 50.2865V38.8503H156.523V50.1667L152.272 44.7479L151.758 45.0609L156.523 51.1348V51.2383H157.776V51.2184L157.795 51.2301L162.634 45.0609Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M162.381 39.9533C160.861 41.8911 161.289 44.4718 162.297 45.0856C163.268 45.676 166.2 45.1371 167.719 43.1998C169.239 41.263 168.733 38.6339 167.803 38.0686C166.873 37.5042 163.901 38.0166 162.381 39.9533Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M163.36 45.3125C163.041 45.3125 162.758 45.2722 162.532 45.1942C162.445 45.1636 162.366 45.1274 162.297 45.0856L167.803 38.0686C168.307 38.3745 168.686 39.2845 168.687 40.3617C168.688 41.2758 168.417 42.3107 167.72 43.1998C166.586 44.6457 164.665 45.3125 163.36 45.3125Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M158.173 53.2936L161.644 55.7122L161.974 55.3451L158.47 52.9057C158.552 52.7441 158.599 52.5661 158.599 52.3775C158.599 51.651 157.929 51.0612 157.104 51.0612C156.278 51.0612 155.61 51.651 155.61 52.3775C155.61 52.5457 155.648 52.7063 155.715 52.8557L152.102 55.1626L152.413 55.5404L155.996 53.2528C156.049 53.3048 156.106 53.3528 156.169 53.3956L153.714 58.0053L154.194 58.2036L156.634 53.6204C156.686 53.6352 156.737 53.652 156.791 53.6632V59.6367H157.322V53.6729C157.387 53.6653 157.45 53.652 157.513 53.6372L159.971 58.2515L160.451 58.0532L157.989 53.4333C158.054 53.3895 158.117 53.3456 158.173 53.2936Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M162.428 32.8108C162.428 36.7001 159.126 39.1641 157.12 39.1641C155.19 39.1641 151.812 36.7001 151.812 32.8108C151.812 28.9219 156.623 26.0002 157.12 26.0012C157.574 26.0022 162.428 28.9219 162.428 32.8108Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M151.812 32.8086C151.812 28.9998 156.143 26.1759 157.066 26.0062C156.349 26.1678 151.812 29.0319 151.812 32.8086Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M157.12 39.1641C155.19 39.1641 151.812 36.7001 151.812 32.8108C151.812 29.0341 156.349 26.17 157.066 26.0083C157.085 26.0048 157.103 26.0027 157.12 26.0012V39.1641Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M100 159C118.778 159 134 143.778 134 125C134 106.222 118.778 91 100 91C81.2223 91 66 106.222 66 125C66 143.778 81.2223 159 100 159Z",
    fill: "#21AAE9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6774 131.431V133.637H83.4017V131.431H85.6774ZM82.7227 134.352H86.3573V130.717H82.7227V134.352Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 134.294V141.81H80.7186V123.268H98.1883V119.209L109.179 108.986L120.171 119.208V141.81H114.887V134.294C114.887 131.145 112.333 128.582 109.193 128.582C106.053 128.582 103.5 131.145 103.5 134.294ZM109.251 108.067L109.179 108.002L97.5847 118.786L97.4688 118.892V122.547H80V142.531H104.219V134.294C104.219 131.543 106.45 129.305 109.193 129.305C111.936 129.305 114.168 131.543 114.168 134.294V142.531H120.89V118.892L109.251 108.067Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6774 135.979V138.183H83.4017V135.979H85.6774ZM82.7227 138.898H86.3573V135.264H82.7227V138.898Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6786 135.979V138.183H93.4014V135.979H95.6786ZM92.7227 138.898H96.3573V135.264H92.7227V138.898Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6774 126.893V129.098H83.4017V126.893H85.6774ZM82.7227 129.812H86.3573V126.178H82.7227V129.812Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6786 131.431V133.637H93.4014V131.431H95.6786ZM92.7227 134.352H96.3573V130.717H92.7227V134.352Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1314 131.431V133.637H88.8549V131.431H91.1314ZM88.1758 134.352H91.8105V130.717H88.1758V134.352Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6786 126.893V129.098H93.4014V126.893H95.6786ZM92.7227 129.812H96.3573V126.178H92.7227V129.812Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1314 135.979V138.183H88.8549V135.979H91.1314ZM88.1758 138.898H91.8105V135.264H88.1758V138.898Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1314 126.893V129.098H88.8549V126.893H91.1314ZM88.1758 129.812H91.8105V126.178H88.1758V129.812Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M107.52 119.143V115.973H109.769V119.143H112.917V121.392H109.769V124.563H107.52V121.392H104.329V119.143H107.52ZM106.817 125.266H110.472V122.096H113.62V118.44H110.472V115.27H106.817V118.44H103.625V122.096H106.817V125.266Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M71 251C89.7777 251 105 235.778 105 217C105 198.222 89.7777 183 71 183C52.2223 183 37 198.222 37 217C37 235.778 52.2223 251 71 251Z",
    fill: "#21AAE9"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7242 219.034L82.3302 225.644L83.1988 224.172C86.4878 218.597 85.6021 211.525 81.0424 206.97C76.4972 202.41 69.4175 201.523 63.8299 204.806L62.3597 205.671L68.9644 212.275L69.7005 212.081C71.4893 211.603 73.3265 212.093 74.6169 213.381C75.9032 214.67 76.3893 216.51 75.9168 218.301L75.7242 219.034ZM82.6124 227.874L74.1889 219.448L74.584 217.952C74.93 216.638 74.5772 215.293 73.6415 214.356C72.701 213.415 71.3573 213.065 70.0525 213.413L68.5495 213.808L60.1253 205.386L63.1293 203.618C69.263 200.014 77.0304 200.993 82.0184 205.998C87.021 210.995 87.995 218.756 84.3862 224.872L82.6124 227.874ZM59.6716 208.357L58.8047 209.83C55.5178 215.41 56.4057 222.481 60.9661 227.024C63.6297 229.692 67.1777 231.162 70.9587 231.162C73.4946 231.162 75.9928 230.48 78.1821 229.185L79.6501 228.32L73.0401 221.715L72.3046 221.909C70.5173 222.386 68.6786 221.9 67.3903 220.611C66.0977 219.323 65.6125 217.486 66.0855 215.697L66.2816 214.961L59.6716 208.357ZM70.9587 232.54C66.8087 232.54 62.9134 230.927 59.9907 228C54.9875 223.012 54.0101 215.253 57.6168 209.13L59.3865 206.124L67.8181 214.545L67.4183 216.048C67.0718 217.357 67.4237 218.696 68.3609 219.632C69.3014 220.576 70.6438 220.926 71.9493 220.578L73.4521 220.178L81.8831 228.602L78.8827 230.373C76.4815 231.792 73.7421 232.54 70.9587 232.54ZM71.0005 196.379C65.4888 196.379 60.3064 198.524 56.412 202.42C52.5207 206.308 50.3779 211.486 50.3779 217.002C50.3779 222.516 52.5207 227.694 56.412 231.583C60.3085 235.478 65.4895 237.622 71.0005 237.622C76.5142 237.622 81.6959 235.478 85.5884 231.583C93.6331 223.542 93.6338 210.46 85.5898 202.42C81.6959 198.524 76.5142 196.379 71.0005 196.379ZM71.0005 239C65.1217 239 59.5949 236.712 55.4365 232.558C51.2857 228.409 49 222.883 49 217.002C49 211.117 51.2857 205.595 55.4365 201.446C59.5921 197.289 65.121 195 71.0005 195C76.8813 195 82.4102 197.289 86.5644 201.446C95.1465 210.023 95.1444 223.979 86.563 232.558C82.4102 236.712 76.8834 239 71.0005 239Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M71 349C89.7777 349 105 333.778 105 315C105 296.222 89.7777 281 71 281C52.2223 281 37 296.222 37 315C37 333.778 52.2223 349 71 349Z",
    fill: "#21AAE9"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8404 314.562L92.7188 314.423C89.8731 311.2 85.7767 309.351 81.477 309.351C81.1769 309.351 80.932 309.593 80.9278 309.893L80.7892 320.838H51.0719C50.769 320.838 50.5232 321.084 50.5232 321.387V325.849C50.5232 326.153 50.769 326.398 51.0719 326.398H94.2382C94.5417 326.398 94.7874 326.153 94.7874 325.849V319.707C94.7874 317.81 94.0962 315.983 92.8404 314.562Z",
    fill: "#FBB040",
    fillOpacity: 0.6
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9056 298.999H52.304C49.931 298.999 48 300.93 48 303.303V317.669C48 320.042 49.931 321.973 52.304 321.973H74.9056C77.2786 321.973 79.2095 320.042 79.2095 317.669V303.303C79.2095 300.93 77.2786 298.999 74.9056 298.999Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4342 326.579C90.4342 328.438 88.9267 329.945 87.0681 329.945C85.2095 329.945 83.7029 328.438 83.7029 326.579C83.7029 324.721 85.2095 323.214 87.0681 323.214C88.9267 323.214 90.4342 324.721 90.4342 326.579Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0659 323.948C85.6137 323.948 84.4319 325.13 84.4319 326.582C84.4319 328.035 85.6137 329.216 87.0659 329.216C88.5181 329.216 89.6999 328.035 89.6999 326.582C89.6999 325.13 88.5181 323.948 87.0659 323.948ZM87.0659 330.68C84.8068 330.68 82.9688 328.841 82.9688 326.582C82.9688 324.323 84.8068 322.486 87.0659 322.486C89.325 322.486 91.1632 324.323 91.1632 326.582C91.1632 328.841 89.325 330.68 87.0659 330.68Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M74.912 299.065H52.3651C49.9967 299.065 48.0701 300.95 48.0701 303.266V311.176H79.2065V303.266C79.2065 300.95 77.2799 299.065 74.912 299.065Z",
    fill: "#074EA3",
    fillOpacity: 0.12
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6992 310.692L66.6746 304.664C66.4578 304.478 66.1517 304.436 65.8924 304.555C65.633 304.674 65.4664 304.934 65.4664 305.219V308.053H53.9814C53.5775 308.053 53.25 308.381 53.25 308.785V313.355C53.25 313.759 53.5775 314.087 53.9814 314.087H65.4664V316.92C65.4664 317.203 65.6279 317.459 65.883 317.581C65.9833 317.629 66.0905 317.652 66.1976 317.652C66.3617 317.652 66.5249 317.597 66.6576 317.49L73.683 311.816C73.8522 311.679 73.9508 311.475 73.9543 311.258C73.9577 311.041 73.8641 310.833 73.6992 310.692Z",
    fill: "#FBB040",
    fillOpacity: 0.6
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5286 317.738C94.2208 316.566 93.6367 315.468 92.8375 314.564L92.7159 314.425C90.7969 312.252 88.3066 310.69 85.5127 309.909C85.3478 309.863 85.1701 309.896 85.0332 310C84.8963 310.104 84.8164 310.265 84.8164 310.438V317.877C84.8164 318.18 85.0621 318.426 85.3648 318.426H93.9972C94.1681 318.426 94.3279 318.348 94.4325 318.212C94.5363 318.078 94.5711 317.903 94.5286 317.738Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2221 322.486C54.9627 322.486 53.125 324.323 53.125 326.582C53.125 328.841 54.9627 330.68 57.2221 330.68C59.4815 330.68 61.3191 328.841 61.3191 326.582C61.3191 324.323 59.4815 322.486 57.2221 322.486Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0659 322.486C84.8068 322.486 82.9688 324.323 82.9688 326.582C82.9688 328.841 84.8068 330.68 87.0659 330.68C89.325 330.68 91.1632 328.841 91.1632 326.582C91.1632 324.323 89.325 322.486 87.0659 322.486Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M53.25 311.07V313.355C53.25 313.759 53.5775 314.087 53.9814 314.087H65.4664V316.92C65.4664 317.203 65.6279 317.459 65.883 317.581C65.9833 317.629 66.0905 317.652 66.1976 317.652C66.3617 317.652 66.5249 317.597 66.6576 317.49L73.683 311.816C73.8514 311.68 73.9508 311.475 73.9543 311.259C73.9551 311.194 73.9466 311.131 73.9313 311.07H53.25Z",
    fill: "#F7941E"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2188 323.687C55.6226 323.687 54.324 324.986 54.324 326.582C54.324 328.178 55.6226 329.477 57.2188 329.477C58.8149 329.477 60.1136 328.178 60.1136 326.582C60.1136 324.986 58.8149 323.687 57.2188 323.687Z",
    fill: "#074EA3",
    fillOpacity: 0.12
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0669 323.687C85.471 323.687 84.1719 324.986 84.1719 326.582C84.1719 328.178 85.471 329.477 87.0669 329.477C88.6636 329.477 89.962 328.178 89.962 326.582C89.962 324.986 88.6636 323.687 87.0669 323.687Z",
    fill: "#074EA3",
    fillOpacity: 0.12
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M87 444C105.778 444 121 428.778 121 410C121 391.222 105.778 376 87 376C68.2223 376 53 391.222 53 410C53 428.778 68.2223 444 87 444Z",
    fill: "#21AAE9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7156 408.109C84.7361 408.109 83.1317 406.501 83.1317 404.522C83.1317 402.542 84.7361 400.938 86.7156 400.938C88.6988 400.938 90.3033 402.542 90.3033 404.522C90.3033 406.501 88.6988 408.109 86.7156 408.109ZM86.7156 413.509C85.7277 413.509 84.9255 412.707 84.9255 411.715C84.9255 410.727 85.7277 409.925 86.7156 409.925C87.7072 409.925 88.5094 410.727 88.5094 411.715C88.5094 412.707 87.7072 413.509 86.7156 413.509ZM89.3302 391.111L86.723 389.001L84.1158 391.111C79.9488 394.475 77.531 399.541 77.531 404.897V415.875H95.9039V404.889C95.9039 399.537 93.4898 394.475 89.3302 391.111Z",
    fill: "#88D7F3"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M86.717 408.109C84.7375 408.109 83.1331 406.501 83.1331 404.522C83.1331 402.542 84.7375 400.938 86.717 400.938C88.7003 400.938 90.3047 402.542 90.3047 404.522C90.3047 406.501 88.7003 408.109 86.717 408.109ZM86.717 413.509C85.7291 413.509 84.9269 412.707 84.9269 411.715C84.9269 410.727 85.7291 409.925 86.717 409.925C87.7086 409.925 88.5108 410.727 88.5108 411.715C88.5108 412.707 87.7086 413.509 86.717 413.509ZM88.6594 397.487L86.7245 395.92L84.7858 397.487C81.6958 399.987 79.8982 403.749 79.8982 407.723V415.875H93.5395V407.715C93.5395 403.745 91.7457 399.987 88.6594 397.487Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0679 418.473H77.5714C76.3585 418.473 75.375 417.49 75.375 416.277C75.375 415.064 76.3585 414.08 77.5714 414.08H96.0679C97.2809 414.08 98.2643 415.064 98.2643 416.277C98.2643 417.49 97.2809 418.473 96.0679 418.473Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0017 426.703L78.4766 426.178L81.1788 423.475V417.407H81.9216V423.783L79.0017 426.703Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5514 428.402H83.8086V417.405H84.5514V428.402Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9925 429.18L87.3943 422.581V417.404H88.1371V422.274L94.5176 428.655L93.9925 429.18Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1686 421.922H92.4258V417.961H93.1686V421.922Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1834 428.774C83.6973 428.774 83.3014 429.17 83.3014 429.656C83.3014 430.143 83.6973 430.538 84.1834 430.538C84.67 430.538 85.0655 430.143 85.0655 429.656C85.0655 429.17 84.67 428.774 84.1834 428.774ZM84.1834 431.281C83.2876 431.281 82.5586 430.553 82.5586 429.656C82.5586 428.761 83.2876 428.032 84.1834 428.032C85.0796 428.032 85.8083 428.761 85.8083 429.656C85.8083 430.553 85.0796 431.281 84.1834 431.281Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7967 422.024C92.3106 422.024 91.9147 422.42 91.9147 422.906C91.9147 423.393 92.3106 423.788 92.7967 423.788C93.2832 423.788 93.6788 423.393 93.6788 422.906C93.6788 422.42 93.2832 422.024 92.7967 422.024ZM92.7967 424.531C91.9009 424.531 91.1719 423.802 91.1719 422.906C91.1719 422.01 91.9009 421.282 92.7967 421.282C93.6929 421.282 94.4216 422.01 94.4216 422.906C94.4216 423.802 93.6929 424.531 92.7967 424.531Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9685 426.454C77.4823 426.454 77.0864 426.85 77.0864 427.336C77.0864 427.823 77.4823 428.218 77.9685 428.218C78.455 428.218 78.8506 427.823 78.8506 427.336C78.8506 426.85 78.455 426.454 77.9685 426.454ZM77.9685 428.961C77.0727 428.961 76.3438 428.232 76.3438 427.336C76.3438 426.44 77.0727 425.712 77.9685 425.712C78.8647 425.712 79.5933 426.44 79.5933 427.336C79.5933 428.232 78.8647 428.961 77.9685 428.961Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9881 428.774C94.5016 428.774 94.1061 429.17 94.1061 429.656C94.1061 430.143 94.5016 430.538 94.9881 430.538C95.4743 430.538 95.8702 430.143 95.8702 429.656C95.8702 429.17 95.4743 428.774 94.9881 428.774ZM94.9881 431.281C94.092 431.281 93.3633 430.553 93.3633 429.656C93.3633 428.761 94.092 428.032 94.9881 428.032C95.8839 428.032 96.613 428.761 96.613 429.656C96.613 430.553 95.8839 431.281 94.9881 431.281Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0753 407.384V413.203H72C72 413.203 72.0152 407.384 76.0753 407.384Z",
    fill: "#88D7F3"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4451 407.384V413.203H101.521C101.521 413.203 101.505 407.384 97.4451 407.384Z",
    fill: "#88D7F3"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M435 94V53C435 50.2386 432.761 48 430 48H192",
    stroke: "#0693E3",
    strokeOpacity: 0.4
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M105 218H251C253.761 218 256 220.239 256 223V263",
    stroke: "#0693E3",
    strokeOpacity: 0.4
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M136 129H189",
    stroke: "#0693E3",
    strokeOpacity: 0.4
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M127 410H219",
    stroke: "#0693E3",
    strokeOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_2",
    x1: 597.919,
    y1: 317.535,
    x2: 599.066,
    y2: 317.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#2B6ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#2E66D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#3160D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#3260D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#335ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#355BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#355ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#3855CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3953CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3B4FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3C4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#3D4CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#453EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#463DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#473CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#4E2FB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4F2EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#4F2DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#502DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#502CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#512BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#512AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#5229AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#5228AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#5328AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#5327AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5327AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_116_2",
    x1: 591.275,
    y1: 312.801,
    x2: 595.701,
    y2: 326.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#0093D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#0095D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#0097D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334773,
    stopColor: "#0098D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#0098D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#009AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#009DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00A0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#00A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00A1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#00A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00A5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#00A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00A6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#00A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665227,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#00B2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#00B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#00B9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00BBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_116_2",
    x1: 590.379,
    y1: 322.008,
    x2: 597.366,
    y2: 317.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405615,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#00B6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#00B6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#00B5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#00B5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#00B5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#00B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#00B5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#00B5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00B4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00B4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00B3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00B3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00B3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00B1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959438,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_116_2",
    x1: 597.663,
    y1: 321.517,
    x2: 593.355,
    y2: 322.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2770DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2B6BDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#2D67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#2E65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3260D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#345BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523437,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3559CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#3856CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3954CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#3D4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#3D4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4048C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#4145C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#453EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#463CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#473BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4938B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#4A35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2FB2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 530,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_116_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(589 315)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroAiLot3);
export default __webpack_public_path__ + "static/media/hero-ai-lot3.3059de49d20b2c2ba5f4b5e0308c6c36.svg";
export { ForwardRef as ReactComponent };